export const messages = {
    "en": {
      "countryCode": "gb",
      "actionBar": {
        "bar": {
          "inProgress": "Drafts",
          "latest": "Closed Reports"
        },
        "sideMenu": {
          "saveModifications": "Save Modifications",
          "reportOverview": "Condition Report Overview",
          "signReport": "Sign Condition Report",
          "closeReport": "Close Condition Report",
          "printReport": "Print Condition Report",
          "deleteReport": "Delete current Condition Report",
          "deleteReportOfflineWarning": "Warning, this element is not synchronized !",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "confirmDeletion": "Confirm deletion"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Delete alteration",
          "changeAlterationTitle": "Change alteration title",
          "changeAlterationType": "Change alteration type",
          "titleModalHeader": "Edit alteration title",
          "titleModalButton": "Validate"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Username and/or password incorrect",
            "network": "Communication with server has failed"
          },
          "form": {
            "password": {
              "error": "Please enter your username",
              "label": "Password"
            },
            "submit": "Log in",
            "submitting": "Logging in",
            "username": {
              "error": "Please enter your password",
              "label": "Username"
            }
          }
        },
        "renew": {
          "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
          "spinner": "Getting you back online"
        }
      },
      cameraScanner: {
        scanCode: "Scan the barcode",
        cancel: "Cancel",
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Close Condition Report",
        "title": "Close Condition Report",
        "notificationContent": "The report '{referenceNumber}' has been closed",
        "warningMessage": "Once closed, the Condition Report cannot be modified nor deleted ",
        "warningQuestion": "Are you sure that you want to close the Condition Report?",
        "transferingFile": "Transfering PDF document...",
        "fileGeneration": "Generating final PDF document...",
        "reportClosing": "Closing the current condition report..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type of Damage: ",
          "alterationsTitle": "Damages: ",
          "createAlterationButtonLabel": "Damage",
          "levelTitle": "Level 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Confirm deletion of damage",
          "precisionPlaceholder": "Select sub-category",
          "thesaurusTermWarningMessage": "The selected damage does not match the material",
          "typeOfAlterationPlaceholder": "Select type of Observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations:",
          "commentsPlaceholder": "Precise…",
          "deleteConfirmationMessage": "Confirm deletion ?",
          "defaultImageConfirmationMessage": "Set as default image ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Confirm deletion of zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Name of Element",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Material ",
          "deleteConfirmationMessage": "Confirm deletion of material",
          "levelTitle": "Level 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materials:",
          "thesaurusTermWarningMessage": "The selected material does not match the type of observation"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirm deletion of observation",
          "levelTitle": "Level 1",
          "observationLabel": "Type of Observation:",
          "observationsTitle": "Observations:"
        },
        "submit": "Save modifications",
        "submitError": "Defects could not be updated",
        "submitting": "Saving…"
      },
      "drawingEditor": {
        "title": "Detailed Damage",
        "imageTitlePlaceholder": "Type image caption",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Select a damage",
        "observationPlaceholder": "Enter Observation",
        "validate": "Save",
        "errors": {
          "missingTitleOrType": "A title or a type of alteration is required for every alterations."
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Further information",
            "validateButton": "Validate"
          },
          "titlePlaceHoder": "Alteration title...",
          "typeOfAlterationPlaceholder": "Select a type of alteration..."
        }
      },
      "editItemScreen": {
        "author": "Author",
        "confirmButton": "Save",
        "editButton": "Edit",
        "inventoryNumber": "Inventory Number",
        "saveNotification": {
          "errorMessage": "En error occured while saving the item",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Item successfully saved"
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been deleted"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "This inventory number is already attributed"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Report N° {refNumber}",
        "reportStatusInProgress": "In Progress",
        "reportIdentifiers": {
          "accordionPanelTitle": "GENERAL INFORMATION",
          "referenceNumber": "Reference Number",
          "numberingInformation": "Leave this field blank to activate the automated numbering once the report has been saved",
          "otherIdentifiers": "Other Identifiers",
          "reportReason": "Reason of Condition Report",
          "precision": "Detail",
          "reportType": "Report type",
          "reportTypePlaceholder": "Select a report type",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Date of report",
          "reportDoneInThePresenceOf": "Report written in the presence of",
          "andOf": "and",
          "name": "Name/Surname, Role",
          "role": "Role",
          "coordinates": "Contact info",
          "email": "Email",
          "signer": "Persons authorized to sign the report",
          "reportPlace": "Place",
          "customer": "Customer",
          "precisions": "Details",
          "linkedProject": "Related Project",
          "linkedMovement": "Related Movement",
          "technicsAndMaterials": "Techniques and Materials",
          "comments": "Comments"
        },
        "alterations": {
          "accordionPanelTitle": "DAMAGES",
          "mediasSectionTitle": "REPORT's IMAGES",
          "globalAlterationSectionTitle": "GENERAL DAMAGES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Create",
            "alterationTypeLabel": "Damage type",
            "precisionLabel": "Precision"
          },
          "tabTitle": "Alterations",
          "viewMenu": {
            "alterationTypeView": "Alteration type view",
            "imageView": "Image view",
            "titleView": "Title view"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION AND MANIPULATION"
        },
        "observations": {
          "tabTitle": "Report",
          "accordionPanelTitle": "GENERAL OBSERVATIONS & RECOMMENDATIONS",
          "commentsFieldLabel": "Comments",
          "interventionToSchedule": "Scheduled interventions",
          "interventionToSchedulePlaceholder": "Choose an intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "State of conservation",
          "stateOfConservationPlaceholder": "Choose a state",
          "typeOfStateOfConservation": "Type of state",
          "treatmentPriority": "Treatment priority",
          "treatmentPriorityPlaceholder": "Choose a priority"
        },
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "An error occurred when saving the Condition Report",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Condition Report has been saved"
        },
        "deleteAlert": {
          "errorMessage": "An error occurred when deleting the Condition Report",
          "successMessage": "Condition Report has been deleted"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been cancelled"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editRecordScreen": {
        "foldAll": "Fold all",
        "unfoldAll": "Unfold all",
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
        "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
      },
      "itemCreationImagePopup": {
        "title": "Add an image",
        "addImage": "ADD AN IMAGE",
        "ignore": "LATER, IGNORE THIS STAGE"
      },
      "itemSearchScreen": {
        "createNewItem": "CREATE NEW ITEM"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "An error occured during the document downloading",
          "downloadSuccess": "The document {docTitle} has been dowloaded",
          "open": "OPEN DOCUMENT",
          "title": "Completed Condition Reports"
        },
        "inProgress": {
          "edit": "EDIT CONDITION REPORT",
          "title": "Drafts"
        },
        "concernedItem": "Related Objects",
        "nbResults": "{nbResults} Results",
        "noResults": "No Results"
      },
      "locationSelector": {
        "inputPlaceholder": "Type a location",
        "title": "Select a location",
        "validate": "Validate"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Undefined",
          "yes": "Yes"
        },
        "entitySelect": {
          "modalPlaceholder": "Keywords or identifiers..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Deployment",
          "checkForUpdate": {
            "help": "If an update is available, it will be installed automatically.",
            "title": "Please check for updates"
          },
          "clearCache": {
            "help": "If you are offline, this process will remove access to all data stored on your device",
            "title": "Clear cache memory"
          },
          "overrideLocale": {
            "help": "The english langage will be used and your device’s settings will be ignored",
            "title": "Force english langage"
          },
          "resetLocaleOverride": {
            "help": "The langage will depend on your device’s settings",
            "title": "Reset the language"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Are you sure that you want to log out?"
      },
      "offlineRibbon": {
        "offline": "You are now offline",
        "online": "You are now online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Preparing document",
          "object": "Object",
          "generalDigest": "General Observations",
          "defects": "Damages",
          "contextAndSignatures": "Context and Signatures",
          "documentReady": "Document is now ready!"
        },
        "title": "Overview",
        "renderFailureAlert": "Unable to render the PDF, please try again"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventory Number : ",
          "title": "Title : ",
          "author": "Artist / Author :",
          "creationDate": "Creation date : ",
          "typology": "Typology : ",
          "denomination": "Denomination : ",
          "materialsAndTechniques": "Materials and techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :"
        },
        "alterationsSection": {
          "detailedAlteration": "Damage details",
          "noAnnotation": "No annotation to display",
          "observationLabel": "Obs.",
          "sectionTitle": "Damages details"
        },
        "finalObservationsSection": {
          "sectionTitle": "Final observations"
        },
        "contextSection": {
          "comments": "Comments :",
          "matAndTechs": "Technics and materials :",
          "reportDate": "Report date :",
          "reportPlace": "Report place :",
          "reportReference": "Report reference :",
          "sectionTitle": "Context",
          "reportType": "Report type : ",
          "reportReason": "Reason of condition report : "
        },
        "reportSection": {
          "interventionsToSchedule": "Interventions to schedule : ",
          "sectionTitle": "Report",
          "signatoriesTitle": "Report made in presence of :",
          "stateOfConservation": "State of conservation : ",
          "treatmentPriority": "Treatment priority : "
        },
        "footer": {
          "prefix": "CONDITION REPORT",
          "separator": "- Page "
        },
        "generationFailureAlert": "PDF generation failed, please try again"
      },
      "proxy": {
        "error": {
          "default": "An error occured on the resource {uri}",
          "network": "Communication with the server has failed",
          "notFound": "The resource {uri} could not be found",
          "tokenHasExpired": "Your session has expired"
        }
      },
      "search": {
        "noResults": "No Results",
        "options": {
          "sortType": {
            "creationDate": "Date of Creation",
            "identifier": "Main identifier",
            "lastModification": "Last Modification",
            "mainTitle": "Main Title",
            "referenceNumber": "Reference number"
          }
        },
        "queryPlaceholder": "Search",
        "title": "Objects",
        "totalCount": "{totalResults}  Result(s) : 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "createNewReport": "CREATE NEW CONDITION REPORT",
        "createNewReportFromLast": "CREATE CONDITION REPORT USING THE LATEST REPORT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Latest Condition Report",
        "materialsAndTechniques": "Materials / Techniques",
        "measurements": "Measurements",
        "noLinkedItem": "No item is linked to this condition report"
      },
      "serviceWorker": {
        "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application."
      },
      "signatureModuleScreen": {
        "cardTitle": "Signatory ",
        "eraseSignature": "Clear Signature",
        "missingSignature": "The Condition Report has not been signed",
        "nameLabel": "Name  / Surname",
        "presentSignature": "The Condition Report has been signed",
        "saveSignature": "Save",
        "signatureStatus": "Status of Signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronization",
        "lastFetch": "Last fetching",
        "duration": "Duration",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Last synchronization",
        "noEntityToSync": "No entity to synchronize",
        "connectionWarningPrefix": "You must have an internet connection to be able to",
        "connectWarningSend": "send",
        "connectWarningRetrieve": "retrive",
        "connectionWarningSuffix": "data",
        "noDataToSync": "No data to synchronize for now",
        "localIconInfoPrefix": "The icon",
        "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
        "retrieveAll": "Retrieve All",
        "finishedSynchros": "Finished synchronizations",
        "syncAll": "Sychronize all",
        "remainsToSynchronize": "Remains to synchronize",
        "cleanImageCache": "Clean gohst media in cache",
        "cachedImagedCleaned": "Gohst media have been cleaned !",
        "cleanCacheDown": "Clear the cache",
        "cacheDownCleaned": "The cache has been cleared",
        "cleanCacheUp": "Delete every unsynchronized modifications",
        "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Audit records",
        "audits": "Audit campaings",
        "thesaurusTerms": "Thesaurus terms",
        "thesaurus": "Thesaurus",
        "entityFields": "System data",
        "collaborators": "Collaborators",
        "authorities": "Authorities",
        "aliases": "Aliases",
        "locations": "Locations",
        "conditionReports": "Condition reports",
        "works": "Works",
        "expressions": "Expressions",
        "manifestations": "Manifestations"
      },
      "time": {
        "hours": "hour(s)",
        "minutes": "minute(s)",
        "seconds": "second(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Create term",
        "openButtonTitle": "Create term",
        "createButton": "Confirm",
        "anotherTermButton": "Confirm and create other term",
        "cancelButton": "Cancel",
        "preferedTermLabel": "Preferred term ",
        "synonymLabel": "Used for",
        "genericTermPlaceholder": "Generic",
        "selectSpecificLabel": "Select specific terms",
        "disabledOffline": "Creating a thesaurusTerm while offline is not allowed"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creation",
        errors: {
          searchError: "The search was unsuccessful",
          fetchError: "Unable to retrieve thesaurus terms"
        },
        "modalSearchInputPlaceholder": "Research a term",
        "selectionTabTitle": "Selection",
        "thesaurusTermSelectorModalTitle": "Select a term",
        "validate": "Validate"
      },
      "state": {
        "all": "All",
        "archived": "Archived",
        "canceled": "Canceled",
        "finalized": "Finalized",
        "inPreparation": "In preparation",
        "inProgress": "In progress",
        "programmed": "Programmed",
        "toValidated": "Needs validation",
        "validated": "Validated",
        "aborted": "Aborted",
        "success": "Successfully finished",
        "error": "Error",
        "none": "No previous synchronization"
      }
    },
    "en-us": {
      "countryCode": "us",
      "actionBar": {
        "bar": {
          "inProgress": "Drafts",
          "latest": "Closed Reports"
        },
        "sideMenu": {
          "saveModifications": "Save Modifications",
          "reportOverview": "Condition Report Overview",
          "signReport": "Sign Condition Report",
          "closeReport": "Close Condition Report",
          "printReport": "Print Condition Report",
          "deleteReport": "Delete current Condition Report",
          "deleteReportOfflineWarning": "Warning, this element is not synchronized !",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "confirmDeletion": "Confirm deletion"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Delete alteration",
          "changeAlterationTitle": "Change alteration title",
          "changeAlterationType": "Change alteration type",
          "titleModalHeader": "Edit alteration title",
          "titleModalButton": "Validate"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Username and/or password incorrect",
            "network": "Communication with server has failed"
          },
          "form": {
            "password": {
              "error": "Please enter your username",
              "label": "Password"
            },
            "submit": "Log in",
            "submitting": "Logging in",
            "username": {
              "error": "Please enter your password",
              "label": "Username"
            }
          }
        },
        "renew": {
          "slowNetwork": "This is taking more time than usual. Please do not quit the application.",
          "spinner": "Getting you back online"
        }
      },
      cameraScanner: {
        scanCode: "Scan the barcode",
        cancel: "Cancel",
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Close Condition Report",
        "title": "Close Condition Report",
        "notificationContent": "The report '{referenceNumber}' has been closed",
        "warningMessage": "Once closed, the Condition Report cannot be modified nor deleted ",
        "warningQuestion": "Are you sure that you want to close the Condition Report?",
        "transferingFile": "Transfering PDF document...",
        "fileGeneration": "Generating final PDF document...",
        "reportClosing": "Closing the current condition report..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type of Damage: ",
          "alterationsTitle": "Damages: ",
          "createAlterationButtonLabel": "Damage",
          "levelTitle": "Level 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Confirm deletion of damage",
          "precisionPlaceholder": "Select sub-category",
          "thesaurusTermWarningMessage": "The selected damage does not match the material",
          "typeOfAlterationPlaceholder": "Select type of Observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations:",
          "commentsPlaceholder": "Precise…",
          "deleteConfirmationMessage": "Confirm deletion ?",
          "defaultImageConfirmationMessage": "Set as default image ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Confirm deletion of zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Name of Element",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Material ",
          "deleteConfirmationMessage": "Confirm deletion of material",
          "levelTitle": "Level 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materials:",
          "thesaurusTermWarningMessage": "The selected material does not match the type of observation"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirm deletion of observation",
          "levelTitle": "Level 1",
          "observationLabel": "Type of Observation:",
          "observationsTitle": "Observations:"
        },
        "submit": "Save modifications",
        "submitError": "Defects could not be updated",
        "submitting": "Saving…"
      },
      "drawingEditor": {
        "title": "Detailed Damage",
        "imageTitlePlaceholder": "Type image caption",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Select a damage",
        "observationPlaceholder": "Enter Observation",
        "validate": "Save",
        "errors": {
          "missingTitleOrType": "A title or a type of alteration is required for every alterations."
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Further information",
            "validateButton": "Validate"
          },
          "titlePlaceHoder": "Alteration title...",
          "typeOfAlterationPlaceholder": "Select a type of alteration..."
        }
      },
      "editItemScreen": {
        "author": "Author",
        "confirmButton": "Save",
        "editButton": "Edit",
        "inventoryNumber": "Inventory Number",
        "saveNotification": {
          "errorMessage": "En error occured while saving the item",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Item successfully saved"
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been deleted"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "This inventory number is already attributed"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "Delete unsynchronized modifications",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Report N° {refNumber}",
        "reportStatusInProgress": "In Progress",
        "reportIdentifiers": {
          "accordionPanelTitle": "GENERAL INFORMATION",
          "referenceNumber": "Reference Number",
          "numberingInformation": "Leave this field blank to activate the automated numbering once the report has been saved",
          "otherIdentifiers": "Other Identifiers",
          "reportReason": "Reason of Condition Report",
          "precision": "Detail",
          "reportType": "Report type",
          "reportTypePlaceholder": "Select a report type",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Date of report",
          "reportDoneInThePresenceOf": "Report written in the presence of",
          "andOf": "and",
          "name": "Name/Surname, Role",
          "role": "Role",
          "coordinates": "Contact info",
          "email": "Email",
          "signer": "Persons authorized to sign the report",
          "reportPlace": "Place",
          "customer": "Customer",
          "precisions": "Details",
          "linkedProject": "Related Project",
          "linkedMovement": "Related Movement",
          "technicsAndMaterials": "Techniques and Materials",
          "comments": "Comments"
        },
        "alterations": {
          "accordionPanelTitle": "DAMAGES",
          "mediasSectionTitle": "REPORT's IMAGES",
          "globalAlterationSectionTitle": "GENERAL DAMAGES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Create",
            "alterationTypeLabel": "Damage type",
            "precisionLabel": "Precision"
          },
          "tabTitle": "Alterations",
          "viewMenu": {
            "alterationTypeView": "Alteration type view",
            "imageView": "Image view",
            "titleView": "Title view"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION AND MANIPULATION"
        },
        "observations": {
          "tabTitle": "Report",
          "accordionPanelTitle": "GENERAL OBSERVATIONS & RECOMMENDATIONS",
          "commentsFieldLabel": "Comments",
          "interventionToSchedule": "Scheduled interventions",
          "interventionToSchedulePlaceholder": "Choose an intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "State of conservation",
          "stateOfConservationPlaceholder": "Choose a state",
          "typeOfStateOfConservation": "Type of state",
          "treatmentPriority": "Treatment priority",
          "treatmentPriorityPlaceholder": "Choose a priority"
        },
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "An error occurred when saving the Condition Report",
          "inventoryNumberNotUnique": "Impossible validation",
          "successMessage": "Condition Report has been saved"
        },
        "deleteAlert": {
          "errorMessage": "An error occurred when deleting the Condition Report",
          "successMessage": "Condition Report has been deleted"
        },
        "deleteModificationsNotification": {
          "errorMessage": "An error occured when deleting unsynchronized modifications",
          "successMessage": "Modifications have been cancelled"
        },
        "fieldDisabledOffline": "This field is not available in offline mode"
      },
      "editRecordScreen": {
        "foldAll": "Fold all",
        "unfoldAll": "Unfold all",
        "medias": {
          "accordionPanelTitle": "ATTACHED MULTIMEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Your account doesn't any associated collaborator, the app may be disfunctionning",
        "noGroupForUserWarningMessage": "You user account needs to be part of group of users to be able to user SKINreporter"
      },
      "itemCreationImagePopup": {
        "title": "Add an image",
        "addImage": "ADD AN IMAGE",
        "ignore": "LATER, IGNORE THIS STAGE"
      },
      "itemSearchScreen": {
        "createNewItem": "CREATE NEW ITEM"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "An error occured during the document downloading",
          "downloadSuccess": "The document {docTitle} has been dowloaded",
          "open": "OPEN DOCUMENT",
          "title": "Completed Condition Reports"
        },
        "inProgress": {
          "edit": "EDIT CONDITION REPORT",
          "title": "Drafts"
        },
        "concernedItem": "Related Objects",
        "nbResults": "{nbResults} Results",
        "noResults": "No Results"
      },
      "locationSelector": {
        "inputPlaceholder": "Type a location",
        "title": "Select a location",
        "validate": "Validate"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Undefined",
          "yes": "Yes"
        },
        "entitySelect": {
          "modalPlaceholder": "Keywords or identifiers..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Deployment",
          "checkForUpdate": {
            "help": "If an update is available, it will be installed automatically.",
            "title": "Please check for updates"
          },
          "clearCache": {
            "help": "If you are offline, this process will remove access to all data stored on your device",
            "title": "Clear cache memory"
          },
          "overrideLocale": {
            "help": "The english langage will be used and your device’s settings will be ignored",
            "title": "Force english langage"
          },
          "resetLocaleOverride": {
            "help": "The langage will depend on your device’s settings",
            "title": "Reset the language"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Are you sure that you want to log out?"
      },
      "offlineRibbon": {
        "offline": "You are now offline",
        "online": "You are now online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Preparing document",
          "object": "Object",
          "generalDigest": "General Observations",
          "defects": "Damages",
          "contextAndSignatures": "Context and Signatures",
          "documentReady": "Document is now ready!"
        },
        "title": "Overview",
        "renderFailureAlert": "Unable to render the PDF, please try again"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventory Number : ",
          "title": "Title : ",
          "author": "Artist / Author :",
          "creationDate": "Creation date : ",
          "typology": "Typology : ",
          "denomination": "Denomination : ",
          "materialsAndTechniques": "Materials and techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :"
        },
        "alterationsSection": {
          "detailedAlteration": "Damage details",
          "noAnnotation": "No annotation to display",
          "observationLabel": "Obs.",
          "sectionTitle": "Damages details"
        },
        "finalObservationsSection": {
          "sectionTitle": "Final observations"
        },
        "contextSection": {
          "comments": "Comments :",
          "matAndTechs": "Technics and materials :",
          "reportDate": "Report date :",
          "reportPlace": "Report place :",
          "reportReference": "Report reference :",
          "sectionTitle": "Context",
          "reportType": "Report type : ",
          "reportReason": "Reason of condition report : "
        },
        "reportSection": {
          "interventionsToSchedule": "Interventions to schedule : ",
          "sectionTitle": "Report",
          "signatoriesTitle": "Report made in presence of :",
          "stateOfConservation": "State of conservation : ",
          "treatmentPriority": "Treatment priority : "
        },
        "footer": {
          "prefix": "CONDITION REPORT",
          "separator": "- Page "
        },
        "generationFailureAlert": "PDF generation failed, please try again"
      },
      "proxy": {
        "error": {
          "default": "An error occured on the resource {uri}",
          "network": "Communication with the server has failed",
          "notFound": "The resource {uri} could not be found",
          "tokenHasExpired": "Your session has expired"
        }
      },
      "search": {
        "noResults": "No Results",
        "options": {
          "sortType": {
            "creationDate": "Date of Creation",
            "identifier": "Main identifier",
            "lastModification": "Last Modification",
            "mainTitle": "Main Title",
            "referenceNumber": "Reference number"
          }
        },
        "queryPlaceholder": "Search",
        "title": "Objects",
        "totalCount": "{totalResults}  Result(s) : 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "createNewReport": "CREATE NEW CONDITION REPORT",
        "createNewReportFromLast": "CREATE CONDITION REPORT USING THE LATEST REPORT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Latest Condition Report",
        "materialsAndTechniques": "Materials / Techniques",
        "measurements": "Measurements",
        "noLinkedItem": "No item is linked to this condition report"
      },
      "serviceWorker": {
        "updateAvailable": "An update has been installed. You can either click here to refresh the page or restart the application."
      },
      "signatureModuleScreen": {
        "cardTitle": "Signatory ",
        "eraseSignature": "Clear Signature",
        "missingSignature": "The Condition Report has not been signed",
        "nameLabel": "Name  / Surname",
        "presentSignature": "The Condition Report has been signed",
        "saveSignature": "Save",
        "signatureStatus": "Status of Signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronization",
        "lastFetch": "Last fetching",
        "duration": "Duration",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Last synchronization",
        "noEntityToSync": "No entity to synchronize",
        "connectionWarningPrefix": "You must have an internet connection to be able to",
        "connectWarningSend": "send",
        "connectWarningRetrieve": "retrive",
        "connectionWarningSuffix": "data",
        "noDataToSync": "No data to synchronize for now",
        "localIconInfoPrefix": "The icon",
        "localIconInfoSuffix": " indicates that the corresponding data has been modified localy and will need to be synchronized with the remote database.",
        "retrieveAll": "Retrieve All",
        "finishedSynchros": "Finished synchronizations",
        "syncAll": "Sychronize all",
        "remainsToSynchronize": "Remains to synchronize",
        "cleanImageCache": "Clean gohst media in cache",
        "cachedImagedCleaned": "Gohst media have been cleaned !",
        "cleanCacheDown": "Clear the cache",
        "cacheDownCleaned": "The cache has been cleared",
        "cleanCacheUp": "Delete every unsynchronized modifications",
        "cacheUpCleaned": "All unsynchronized modifications have been deleted !"
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Audit records",
        "audits": "Audit campaings",
        "thesaurusTerms": "Thesaurus terms",
        "thesaurus": "Thesaurus",
        "entityFields": "System data",
        "collaborators": "Collaborators",
        "authorities": "Authorities",
        "aliases": "Aliases",
        "locations": "Locations",
        "conditionReports": "Condition reports",
        "works": "Works",
        "expressions": "Expressions",
        "manifestations": "Manifestations"
      },
      "time": {
        "hours": "hour(s)",
        "minutes": "minute(s)",
        "seconds": "second(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Create term",
        "openButtonTitle": "Create term",
        "createButton": "Confirm",
        "anotherTermButton": "Confirm and create other term",
        "cancelButton": "Cancel",
        "preferedTermLabel": "Preferred term ",
        "synonymLabel": "Used for",
        "genericTermPlaceholder": "Generic",
        "selectSpecificLabel": "Select specific terms",
        "disabledOffline": "Creating a thesaurusTerm while offline is not allowed"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creation",
        errors: {
          searchError: "The search was unsuccessful",
          fetchError: "Unable to retrieve thesaurus terms"
        },
        "modalSearchInputPlaceholder": "Research a term",
        "selectionTabTitle": "Selection",
        "thesaurusTermSelectorModalTitle": "Select a term",
        "validate": "Validate"
      },
      "state": {
        "all": "All",
        "archived": "Archived",
        "canceled": "Canceled",
        "finalized": "Finalized",
        "inPreparation": "In preparation",
        "inProgress": "In progress",
        "programmed": "Programmed",
        "toValidated": "Needs validation",
        "validated": "Validated",
        "aborted": "Aborted",
        "success": "Successfully finished",
        "error": "Error",
        "none": "No previous synchronization"
      }
    },
    "fr": {
      "actionBar": {
        "bar": {
          "inProgress": "En cours",
          "latest": "Terminés"
        },
        "sideMenu": {
          "saveModifications": "Sauvegarder les modifications",
          "reportOverview": "Aperçu du constat d'état",
          "signReport": "Signer le constat d'état",
          "closeReport": "Clôturer le constat d'état",
          "printReport": "Imprimer le constat d'état",
          "deleteReport": "Supprimer le constat en cours",
          "deleteReportOfflineWarning": "Attention, cet élément n'est pas synchronisé !",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "confirmDeletion": "Confirmer la suppression"
        }
      },
      alterationCard: {
        moreMenu: {
          deleteAlteration: "Supprimer l'altération",
          changeAlterationTitle: "Changer le titre de l'altération",
          changeAlterationType: "Changer le type d'altération",
          titleModalHeader: "Éditer le titre de l'altération",
          titleModalButton: 'Valider',
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vos identifiants sont incorrects",
            "network": "La communication avec le serveur a échoué"
          },
          "form": {
            "password": {
              "error": "Veuillez saisir votre nom d'utilisateur",
              "label": "Mot de passe"
            },
            "submit": "Se connecter",
            "submitting": "Connexion...",
            "username": {
              "error": "Veuillez saisir votre mot de passe",
              "label": "Nom d'utilisateur"
            }
          }
        },
        "renew": {
          "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
          "spinner": "Nous vous reconnectons..."
        }
      },
      cameraScanner: {
        scanCode: "Scanner un code-barre",
        cancel: "Annuler",
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Clôturer",
        "title": "Clôture du constat d'état",
        "notificationContent": "Le constat '{referenceNumber}' a été clôturé",
        "warningMessage": "Un constat clôturé ne peut être modifié ni supprimé",
        "warningQuestion": "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
        "transferingFile": "Transfert du document PDF...",
        "fileGeneration": "Génération du document pdf final...",
        "reportClosing": "Clôture du constat d'état..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type :",
          "alterationsTitle": "Altérations :",
          "createAlterationButtonLabel": "Alteration",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Précision :",
          "deleteConfirmationMessage": "Confirmer la suppression de l'altération et de son contenu ?",
          "precisionPlaceholder": "Sélectionnez un sous-type",
          "thesaurusTermWarningMessage": "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
          "typeOfAlterationPlaceholder": "Sélectionnez un type d'observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations :",
          "commentsPlaceholder": "Précisez...",
          "deleteConfirmationMessage": "Confirmer la suppression ?",
          "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
        },
        "defect": {
          "createElementButtonLabel": "Élément",
          "deleteConfirmationMessage": "Confirmer la suppression de l'élément et de son contenu ?",
          "elementLabel": "Elément :",
          "precisionLabel": "Précision",
          "elementPlaceholder": "Nom de l'élément",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Matériau",
          "deleteConfirmationMessage": "Confirmer la suppression du matériau et de son contenu ?",
          "levelTitle": "Niveau 2",
          "materialLabel": "Matériau :",
          "materialsTitle": "Matériaux :",
          "thesaurusTermWarningMessage": "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirmer la suppression de l'observation et de son contenu ?",
          "levelTitle": "Niveau 1",
          "observationLabel": "Type d'observation :",
          "observationsTitle": "Observations :"
        },
        "submit": "Sauvegarder les modifications",
        "submitError": "L'arbre n'a pas pu être mis à jour",
        "submitting": "Sauvegarde en cours..."
      },
      "drawingEditor": {
        "title": "Altération détaillée",
        "imageTitlePlaceholder": "Saisir la légende de l'image",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Sélectionner une altération",
        "observationPlaceholder": "Entrez une observation",
        "validate": "Enregistrer",
        errors: {
          missingTitleOrType: "Veuillez renseigner un titre ou un type d'altération pour chaque altération.",
        },
        "alterationLine": {
          precisionModal: {
            title: "Précision",
            validateButton: "Valider",
          },
          titlePlaceHoder: "Titre de l'altération...",
          typeOfAlterationPlaceholder: "Type d'altération...",
        },
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Valider",
        "editButton": "Modifier",
        "inventoryNumber": "N° d'inventaire",
        "saveNotification": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "L'objet a été sauvegardé avec succès"
        },
        "deleteNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
          "successMessage": "L'objet a été supprimé avec succès"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
        },
        "menu": {
          "saveModifications": "Sauvegarder les modifications",
          "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
          "offlineShortWarning": "Modifié sur cet appareil"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Constat N° {refNumber}",
        "reportStatusInProgress": "En cours",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFIANTS DU CONSTAT",
          "referenceNumber": "N° de référence",
          "numberingInformation": "Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde",
          "otherIdentifiers": "Autres identifants",
          "reportReason": "Motif du constat",
          "precision": "Précision",
          "reportType": "Type de constat",
          "reportTypePlaceholder": "Sélectionnez un type de constat",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTE DU CONSTAT D'ÉTAT",
          "reportDate": "Date du constat",
          "reportDoneInThePresenceOf": "Constat effectué en présence de",
          "andOf": "Et de",
          "name": "Nom/Prénom, Qualité",
          "role": "Qualité",
          "coordinates": "Coordonnées",
          "email": "Email",
          "signer": "Signataire",
          "reportPlace": "Lieu du constat",
          "customer": "Client/Commanditaire",
          "precisions": "Précisions",
          "linkedProject": "Projet Lié",
          "linkedMovement": "Mouvement Lié",
          "technicsAndMaterials": "Techniques et matériels utilisés",
          "comments": "Commentaires"
        },
        "alterations": {
          "accordionPanelTitle": "ALTÉRATIONS",
          "mediasSectionTitle": "IMAGES DU CONSTAT",
          "globalAlterationSectionTitle": "ALTÉRATIONS GÉNÉRALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Créer",
            "alterationTypeLabel": "Type d'altération",
            "precisionLabel": "Précision"
          },
          "tabTitle": "Altérations",
          viewMenu: {
            alterationTypeView: "Vue par type d'altération",
            imageView: 'Vue photos',
            titleView: 'Vue par titre',
          },
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION ET MANIPULATION"
        },
        "observations": {
          "tabTitle": "Bilan",
          "accordionPanelTitle": "RAPPORT ET OBSERVATIONS",
          "commentsFieldLabel": "Commentaires",
          "interventionToSchedule": "Interventions à prévoir",
          "interventionToSchedulePlaceholder": "Choisissez une intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "Etat du bien",
          "stateOfConservationPlaceholder": "Choisissez un état",
          "typeOfStateOfConservation": "Type d'état",
          "treatmentPriority": "Priorité de traitement",
          "treatmentPriorityPlaceholder": "Choississez une priorité"
        },
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        },
        "saveAlert": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde du constat",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "Constat d'état sauvegardé"
        },
        "deleteAlert": {
          "errorMessage": "Une erreur est survenue pendant la suppression du constat",
          "successMessage": "Constat d'état supprimé"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editRecordScreen": {
        "foldAll": "Réduire tout",
        "unfoldAll": "Déployer tout",
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        }
      },
      "firewall": {
        "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
        "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
      },
      "itemCreationImagePopup": {
        "title": "Ajouter une image",
        "addImage": "AJOUTER UNE IMAGE",
        "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
      },
      "itemSearchScreen": {
        "createNewItem": "CRÉER UN NOUVEL OBJET"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Une erreur est survenue pendant le téléchargement",
          "downloadSuccess": "Le document {docTitle} a été téléchargé",
          "open": "TÉLÉCHARGER LE DOCUMENT",
          "title": "Constats d'état terminés"
        },
        "inProgress": {
          "edit": "EDITER LE CONSTAT",
          "title": "Constats d'état en cours d'édition"
        },
        "concernedItem": "Objet de musée concerné",
        "nbResults": "{nbResults} résultats",
        "noResults": "Aucun résultat"
      },
      "locationSelector": {
        "inputPlaceholder": "Entrez une localisation",
        "title": "Choisissez une localisation",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Non",
          "undefined": "Non défini",
          "yes": "Oui"
        },
        "entitySelect": {
          "modalPlaceholder": "Mots clés ou identifiants..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Déployé le",
          "checkForUpdate": {
            "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
            "title": "Vérifiez les mises à jour"
          },
          "clearCache": {
            "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
            "title": "Vider le cache"
          },
          "overrideLocale": {
            "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
            "title": "Forcer la langue anglaise"
          },
          "resetLocaleOverride": {
            "help": "La langue utilisé dépendra du paramètrage de votre terminal",
            "title": "Réinitialiser la langue"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
      },
      "offlineRibbon": {
        "offline": "Vous êtes hors connexion",
        "online": "Vous êtes connecté"
      },
      "pdfOverviewScreen": {
        "download": "Télécharger",
        "progressBar": {
          "mainLabel": "Génération du document ...",
          "object": "Objet",
          "generalDigest": "Appréciation Générale",
          "defects": "Altérations",
          "contextAndSignatures": "Contexte et signatures",
          "documentReady": "Document prêt !"
        },
        "title": "Aperçu",
        "renderFailureAlert": "Impossible d'afficher le PDF, veuillez réessayer plus tard"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONSTAT D'ETAT - ",
        "objectSection": {
          "sectionTitle": "Objet",
          "inventoryNumber": "N° d'inventaire : ",
          "title": "Titre : ",
          "author": "Artiste / Auteur :",
          "creationDate": "Date de création : ",
          "typology": "Typologie : ",
          "denomination": "Dénomination : ",
          "materialsAndTechniques": "Matériaux et techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :"
        },
        "alterationsSection": {
          "detailedAlteration": "Altération détaillée",
          "noAnnotation": "Aucune annotation à afficher",
          "observationLabel": "Obs.",
          "sectionTitle": "Détail des altérations"
        },
        "finalObservationsSection": {
          "sectionTitle": "Observations finales"
        },
        "contextSection": {
          "comments": "Commentaires :",
          "matAndTechs": "Matériaux et techniques :",
          "reportDate": "Date du constat :",
          "reportPlace": "Lieu : ",
          "reportReference": "Référence du constat :",
          "sectionTitle": "Contexte du présent constat d'état",
          "reportType": "Type de constat : ",
          "reportReason": "Motif du constat : "
        },
        "reportSection": {
          "interventionsToSchedule": "Interventions à prévoir : ",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Constat effectué en présence de :",
          "stateOfConservation": "Etat du bien : ",
          "treatmentPriority": "Priorité de traitement : "
        },
        "footer": {
          "prefix": "CONSTAT D'ETAT",
          "separator": "- Page "
        },
        "generationFailureAlert": "La génération du PDF a échoué, veuillez réessayer plus tard"
      },
      "proxy": {
        "error": {
          "default": "Une erreur s'est produite sur la ressource {uri}",
          "network": "La communication avec le serveur a échoué",
          "notFound": "La ressource {uri} n'a pas été trouvée",
          "tokenHasExpired": "Votre session a expiré"
        }
      },
      "search": {
        "noResults": "Aucun résultat",
        "options": {
          "sortType": {
            "creationDate": "Date de création",
            "identifier": "Identifiant principal",
            "lastModification": "Dernière modification",
            "mainTitle": "Titre principal",
            "referenceNumber": "Numéro de référence"
          }
        },
        "queryPlaceholder": "Mots clés ou N° Inventaire",
        "title": "Objets de musée",
        "totalCount": "{totalResults}  Résultat(s) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "CRÉER UN NOUVEAU CONSTAT",
        "createNewReportFromLast": "CONSTAT À PARTIR DU DERNIER CONSTAT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Dernier constat d'état",
        "materialsAndTechniques": "Matériaux / Techniques",
        "measurements": "Dimensions",
        "noLinkedItem": "Aucun item n'est lié à ce constat d'état"
      },
      "serviceWorker": {
        "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
      },
      "signatureModuleScreen": {
        "cardTitle": "Signataire",
        "eraseSignature": "Signer à nouveau",
        "missingSignature": "Signature manquante",
        "nameLabel": "Nom / Prénom",
        "presentSignature": "Signature présente",
        "saveSignature": "Enregistrer",
        "signatureStatus": "Statut de la signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "Dernière récupération",
        "duration": "Durée",
        "status": "Statut",
        "details": "Détails",
        "lastSynchro": "Dernière synchronisation",
        "noEntityToSync": "Aucune entité à synchroniser",
        "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
        "connectWarningSend": "envoyer",
        "connectWarningRetrieve": "récupérer",
        "connectionWarningSuffix": "des données",
        "noDataToSync": "Aucune donnée à synchroniser pour le moment",
        "localIconInfoPrefix": "L'icône",
        "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
        "retrieveAll": "Tout récupérer",
        "finishedSynchros": "synchronisations terminées",
        "syncAll": "Tout synchroniser",
        "remainsToSynchronize": "Reste à synchroniser",
        cleanImageCache: "Supprimer les images fantômes du cache",
        cachedImagedCleaned: "Les images fantômes ont été supprimées !",
        cleanCacheDown: "Vider le cache",
        cacheDownCleaned: "Le cache a été vidé",
        cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
        cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Fiches de récolement",
        "audits": "Projets de récolement",
        "thesaurusTerms": "Termes de thésaurus",
        "thesaurus": "Thésaurus",
        "entityFields": "Données système",
        "collaborators": "Collaborateurs",
        "authorities": "Autorités",
        "aliases": "Alias",
        "locations": "Localisations",
        "conditionReports": "Constats d'état",
        works: "Oeuvres",
        expressions: "Expressions",
        manifestations: "Manifestations",
      },
      "time": {
        "hours": "heure(s)",
        "minutes": "minute(s)",
        "seconds": "seconde(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Création d'un terme",
        "openButtonTitle": "Créer un terme",
        "createButton": "Valider",
        "anotherTermButton": "Valider et créer un autre terme",
        "cancelButton": "Annuler",
        "preferedTermLabel": "Terme préféré :",
        "synonymLabel": "Employé pour :",
        "genericTermPlaceholder": "Générique :",
        "selectSpecificLabel": "Sélectionner des termes spécifiques",
        disabledOffline: "La création d’un nouveau terme n’est pas disponible en usage hors-ligne de l’application",
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Création",
        errors: {
          searchError: "La recherche a échouée",
          fetchError: "Impossible de récupérer les termes de thésaurus"
        },
        "modalSearchInputPlaceholder": "Rechercher un terme",
        "selectionTabTitle": "Sélection",
        "thesaurusTermSelectorModalTitle": "Sélectionner un terme",
        "validate": "Valider",
      },
      "state": {
        "all": "Tous",
        "archived": "Archivé",
        "canceled": "Annulé",
        "finalized": "Terminé",
        "inPreparation": "En préparation",
        "inProgress": "En cours",
        "programmed": "Planifié",
        "toValidated": "À valider",
        "validated": "Validé",
        "aborted": "Interrompue",
        "success": "Terminée avec succès",
        "error": "Erreur",
        "none": "Aucune synchronisation précédente"
      }
    },
    "fr-ca": {
      "countryCode": "ca",
      "actionBar": {
        "bar": {
          "inProgress": "En cours",
          "latest": "Terminés"
        },
        "sideMenu": {
          "saveModifications": "Sauvegarder les modifications",
          "reportOverview": "Aperçu du constat d'état",
          "signReport": "Signer le constat d'état",
          "closeReport": "Clôturer le constat d'état",
          "printReport": "Imprimer le constat d'état",
          "deleteReport": "Supprimer le constat en cours",
          "deleteReportOfflineWarning": "Attention, cet élément n'est pas synchronisé !",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "confirmDeletion": "Confirmer la suppression"
        }
      },
      alterationCard: {
        moreMenu: {
          deleteAlteration: "Supprimer l'altération",
          changeAlterationTitle: "Changer le titre de l'altération",
          changeAlterationType: "Changer le type d'altération",
          titleModalHeader: "Éditer le titre de l'altération",
          titleModalButton: 'Valider',
        },
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Vos identifiants sont incorrects",
            "network": "La communication avec le serveur a échoué"
          },
          "form": {
            "password": {
              "error": "Veuillez saisir votre nom d'utilisateur",
              "label": "Mot de passe"
            },
            "submit": "Se connecter",
            "submitting": "Connexion...",
            "username": {
              "error": "Veuillez saisir votre mot de passe",
              "label": "Nom d'utilisateur"
            }
          }
        },
        "renew": {
          "slowNetwork": "Cela semble mettre plus de temps que d'habitude, ne quittez pas l'application.",
          "spinner": "Nous vous reconnectons..."
        }
      },
      cameraScanner: {
        scanCode: "Scanner un code-barre",
        cancel: "Annuler",
      },
      "closeReportScreen": {
        "important": "IMPORTANT",
        "close": "Clôturer",
        "title": "Clôture du constat d'état",
        "notificationContent": "Le constat '{referenceNumber}' a été clôturé",
        "warningMessage": "Un constat clôturé ne peut être modifié ni supprimé",
        "warningQuestion": "Souhaitez-vous réellement poursuivre la clôture du constat d'état ?",
        "transferingFile": "Transfert du document PDF...",
        "fileGeneration": "Génération du document pdf final...",
        "reportClosing": "Clôture du constat d'état..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type :",
          "alterationsTitle": "Altérations :",
          "createAlterationButtonLabel": "Alteration",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Précision :",
          "deleteConfirmationMessage": "Confirmer la suppression de l'altération et de son contenu ?",
          "precisionPlaceholder": "Sélectionnez un sous-type",
          "thesaurusTermWarningMessage": "Le type d'altération sélectionné ne correspond pas au matériau ci-dessus",
          "typeOfAlterationPlaceholder": "Sélectionnez un type d'observation"
        },
        "annotation": {
          "annotationsTitle": "Annotations :",
          "commentsPlaceholder": "Précisez...",
          "deleteConfirmationMessage": "Confirmer la suppression ?",
          "defaultImageConfirmationMessage": "Définir comme image par défaut ?"
        },
        "defect": {
          "createElementButtonLabel": "Élément",
          "deleteConfirmationMessage": "Confirmer la suppression de l'élément et de son contenu ?",
          "elementLabel": "Elément :",
          "precisionLabel": "Précision",
          "elementPlaceholder": "Nom de l'élément",
          "precisionPlaceholder": "Précisez..."
        },
        "material": {
          "createMaterialButtonLabel": "Matériau",
          "deleteConfirmationMessage": "Confirmer la suppression du matériau et de son contenu ?",
          "levelTitle": "Niveau 2",
          "materialLabel": "Matériau :",
          "materialsTitle": "Matériaux :",
          "thesaurusTermWarningMessage": "Le matériau sélectionné ne correspond pas au type d'observation ci-dessus"
        },
        "observation": {
          "createObservationButtonLabel": "Observation",
          "deleteConfirmationMessage": "Confirmer la suppression de l'observation et de son contenu ?",
          "levelTitle": "Niveau 1",
          "observationLabel": "Type d'observation :",
          "observationsTitle": "Observations :"
        },
        "submit": "Sauvegarder les modifications",
        "submitError": "L'arbre n'a pas pu être mis à jour",
        "submitting": "Sauvegarde en cours..."
      },
      "drawingEditor": {
        "title": "Altération détaillée",
        "imageTitlePlaceholder": "Saisir la légende de l'image",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Sélectionner une altération",
        "observationPlaceholder": "Entrez une observation",
        "validate": "Enregistrer",
        errors: {
          missingTitleOrType: "Veuillez renseigner un titre ou un type d'altération pour chaque altération.",
        },
        "alterationLine": {
          precisionModal: {
            title: "Précision",
            validateButton: "Valider",
          },
          titlePlaceHoder: "Titre de l'altération...",
          typeOfAlterationPlaceholder: "Type d'altération...",
        },
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Valider",
        "editButton": "Modifier",
        "inventoryNumber": "N° d'inventaire",
        "saveNotification": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde de l'objet",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "L'objet a été sauvegardé avec succès"
        },
        "deleteNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression de l'objet non synchronisés",
          "successMessage": "L'objet a été supprimé avec succès"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Ce numéro d'inventaire est déjà attribué"
        },
        "menu": {
          "saveModifications": "Sauvegarder les modifications",
          "deleteNotSynchronizedNewItem": "Supprimer le nouvel objet",
          "deleteModificationsNotSynchronized": "Supprimer les modifications non synchronisées",
          "offlineWarning": "Les modifications sont sauvegardées sur l'appareil, vous devrez les synchroniser avec la base de données lorsque le réseau sera de nouveau disponible.",
          "offlineShortWarning": "Modifié sur cet appareil"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Constat N° {refNumber}",
        "reportStatusInProgress": "En cours",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFIANTS DU CONSTAT",
          "referenceNumber": "N° de référence",
          "numberingInformation": "Laisser vide pour activer la numérotation automatique à la prochaine sauvegarde",
          "otherIdentifiers": "Autres identifants",
          "reportReason": "Motif du constat",
          "precision": "Précision",
          "reportType": "Type de constat",
          "reportTypePlaceholder": "Sélectionnez un type de constat",
          "tabTitle": "Identification"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTE DU CONSTAT D'ÉTAT",
          "reportDate": "Date du constat",
          "reportDoneInThePresenceOf": "Constat effectué en présence de",
          "andOf": "Et de",
          "name": "Nom/Prénom, Qualité",
          "role": "Qualité",
          "coordinates": "Coordonnées",
          "email": "Email",
          "signer": "Signataire",
          "reportPlace": "Lieu du constat",
          "customer": "Client/Commanditaire",
          "precisions": "Précisions",
          "linkedProject": "Projet Lié",
          "linkedMovement": "Mouvement Lié",
          "technicsAndMaterials": "Techniques et matériels utilisés",
          "comments": "Commentaires"
        },
        "alterations": {
          "accordionPanelTitle": "ALTÉRATIONS",
          "mediasSectionTitle": "IMAGES DU CONSTAT",
          "globalAlterationSectionTitle": "ALTÉRATIONS GÉNÉRALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Créer",
            "alterationTypeLabel": "Type d'altération",
            "precisionLabel": "Précision"
          },
          "tabTitle": "Altérations",
          viewMenu: {
            alterationTypeView: "Vue par type d'altération",
            imageView: 'Vue photos',
            titleView: 'Vue par titre',
          },
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATION ET MANIPULATION"
        },
        "observations": {
          "tabTitle": "Bilan",
          "accordionPanelTitle": "RAPPORT ET OBSERVATIONS",
          "commentsFieldLabel": "Commentaires",
          "interventionToSchedule": "Interventions à prévoir",
          "interventionToSchedulePlaceholder": "Choisissez une intervention",
          "interventionToSchedulePrecision": "Précision :",
          "stateOfConservation": "Etat du bien",
          "stateOfConservationPlaceholder": "Choisissez un état",
          "typeOfStateOfConservation": "Type d'état",
          "treatmentPriority": "Priorité de traitement",
          "treatmentPriorityPlaceholder": "Choississez une priorité"
        },
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        },
        "saveAlert": {
          "errorMessage": "Une erreur est survenue pendant la sauvegarde du constat",
          "inventoryNumberNotUnique": "Validation impossible, le numéro d'identification de la notice existe déjà",
          "successMessage": "Constat d'état sauvegardé"
        },
        "deleteAlert": {
          "errorMessage": "Une erreur est survenue pendant la suppression du constat",
          "successMessage": "Constat d'état supprimé"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Une erreur est survenue pendant la suppression des modifications non synchronisées",
          "successMessage": "Les modifications ont été annulées"
        },
        "fieldDisabledOffline": "La saisie de ce champ n'est pas disponible en mode hors-ligne"
      },
      "editRecordScreen": {
        "foldAll": "Réduire tout",
        "unfoldAll": "Déployer tout",
        "medias": {
          "accordionPanelTitle": "MÉDIAS"
        }
      },
      "firewall": {
        "collabWarningMessage": "Votre compte n'a pas de collaborateur associé, l'application peut dysfonctionner",
        "noGroupForUserWarningMessage": "L'usage de SKINreporter requiert que votre compte utilisateur soit lié à un groupe d'utilisateurs"
      },
      "itemCreationImagePopup": {
        "title": "Ajouter une image",
        "addImage": "AJOUTER UNE IMAGE",
        "ignore": "PLUS TARD, IGNORER CETTE ETAPE"
      },
      "itemSearchScreen": {
        "createNewItem": "CRÉER UN NOUVEL OBJET"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Une erreur est survenue pendant le téléchargement",
          "downloadSuccess": "Le document {docTitle} a été téléchargé",
          "open": "TÉLÉCHARGER LE DOCUMENT",
          "title": "Constats d'état terminés"
        },
        "inProgress": {
          "edit": "EDITER LE CONSTAT",
          "title": "Constats d'état en cours d'édition"
        },
        "concernedItem": "Objet de musée concerné",
        "nbResults": "{nbResults} résultats",
        "noResults": "Aucun résultat"
      },
      "locationSelector": {
        "inputPlaceholder": "Entrez une localisation",
        "title": "Choisissez une localisation",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Non",
          "undefined": "Non défini",
          "yes": "Oui"
        },
        "entitySelect": {
          "modalPlaceholder": "Mots clés ou identifiants..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Déployé le",
          "checkForUpdate": {
            "help": "Si une mise à jour est disponible, elle s'installera automatiquement.",
            "title": "Vérifiez les mises à jour"
          },
          "clearCache": {
            "help": "Si vous êtes hors-ligne, cela supprime l'accès à toutes les données stockées sur l'appareil.",
            "title": "Vider le cache"
          },
          "overrideLocale": {
            "help": "La langue anglaise sera utilisée et le paramétrage de votre terminal ignoré.",
            "title": "Forcer la langue anglaise"
          },
          "resetLocaleOverride": {
            "help": "La langue utilisé dépendra du paramètrage de votre terminal",
            "title": "Réinitialiser la langue"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Etes-vous sûr de vouloir vous déconnecter ?"
      },
      "offlineRibbon": {
        "offline": "Vous êtes hors connexion",
        "online": "Vous êtes connecté"
      },
      "pdfOverviewScreen": {
        "download": "Télécharger",
        "progressBar": {
          "mainLabel": "Génération du document ...",
          "object": "Objet",
          "generalDigest": "Appréciation Générale",
          "defects": "Altérations",
          "contextAndSignatures": "Contexte et signatures",
          "documentReady": "Document prêt !"
        },
        "title": "Aperçu",
        "renderFailureAlert": "Impossible d'afficher le PDF, veuillez réessayer plus tard"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONSTAT D'ETAT - ",
        "objectSection": {
          "sectionTitle": "Objet",
          "inventoryNumber": "N° d'inventaire : ",
          "title": "Titre : ",
          "author": "Artiste / Auteur :",
          "creationDate": "Date de création : ",
          "typology": "Typologie : ",
          "denomination": "Dénomination : ",
          "materialsAndTechniques": "Matériaux et techniques :",
          "dimensions": "Dimensions : ",
          "institution": "Institution :"
        },
        "alterationsSection": {
          "detailedAlteration": "Altération détaillée",
          "noAnnotation": "Aucune annotation à afficher",
          "observationLabel": "Obs.",
          "sectionTitle": "Détail des altérations"
        },
        "finalObservationsSection": {
          "sectionTitle": "Observations finales"
        },
        "contextSection": {
          "sectionTitle": "Contexte du présent constat d'état",
          "reportDate": "Date du constat :",
          "reportReference": "Référence du constat :",
          "comments": "Commentaires :",
          "matAndTechs": "Matériaux et techniques :",
          "reportPlace": "Lieu : ",
          "reportType": "Type de constat : ",
          "reportReason": "Motif du constat : "
        },
        "reportSection": {
          "interventionsToSchedule": "Interventions à prévoir : ",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Constat effectué en présence de :",
          "stateOfConservation": "Etat du bien : ",
          "treatmentPriority": "Priorité de traitement : "
        },
        "footer": {
          "prefix": "CONSTAT D'ETAT",
          "separator": "- Page "
        },
        "generationFailureAlert": "La génération du PDF a échoué, veuillez réessayer plus tard"
      },
      "proxy": {
        "error": {
          "default": "Une erreur s'est produite sur la ressource {uri}",
          "network": "La communication avec le serveur a échoué",
          "notFound": "La ressource {uri} n'a pas été trouvée",
          "tokenHasExpired": "Votre session a expiré"
        }
      },
      "search": {
        "noResults": "Aucun résultat",
        "options": {
          "sortType": {
            "creationDate": "Date de création",
            "identifier": "Identifiant principal",
            "lastModification": "Dernière modification",
            "mainTitle": "Titre principal",
            "referenceNumber": "Numéro de référence"
          }
        },
        "queryPlaceholder": "Mots clés ou N° Inventaire",
        "title": "Objets de musée",
        "totalCount": "{totalResults}  Résultat(s) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "CRÉER UN NOUVEAU CONSTAT",
        "createNewReportFromLast": "CONSTAT À PARTIR DU DERNIER CONSTAT",
        "institutionLabel": "Institution",
        "lastReportLabel": "Dernier constat d'état",
        "materialsAndTechniques": "Matériaux / Techniques",
        "measurements": "Dimensions",
        "noLinkedItem": "Aucun item n'est lié à ce constat d'état"
      },
      "serviceWorker": {
        "updateAvailable": "Une mise à jour a été installée. Cliquez ici pour recharger la page ou relancez l'application"
      },
      "signatureModuleScreen": {
        "cardTitle": "Signataire",
        "eraseSignature": "Signer à nouveau",
        "missingSignature": "Signature manquante",
        "nameLabel": "Nom / Prénom",
        "presentSignature": "Signature présente",
        "saveSignature": "Enregistrer",
        "signatureStatus": "Statut de la signature",
        "title": "Signatures"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "Dernière récupération",
        "duration": "Durée",
        "status": "Statut",
        "details": "Détails",
        "lastSynchro": "Dernière synchronisation",
        "noEntityToSync": "Aucune entité à synchroniser",
        "connectionWarningPrefix": "Vous devez être connecté à internet pour pouvoir",
        "connectWarningSend": "envoyer",
        "connectWarningRetrieve": "récupérer",
        "connectionWarningSuffix": "des données",
        "noDataToSync": "Aucune donnée à synchroniser pour le moment",
        "localIconInfoPrefix": "L'icône",
        "localIconInfoSuffix": " indique que les données correspondantes ont été modifiées localement et devront être synchronisées avec la base de données distante.",
        "retrieveAll": "Tout récupérer",
        "finishedSynchros": "synchronisations terminées",
        "syncAll": "Tout synchroniser",
        "remainsToSynchronize": "Reste à synchroniser",
        cleanImageCache: "Supprimer les images fantômes du cache",
        cachedImagedCleaned: "Les images fantômes ont été supprimées !",
        cleanCacheDown: "Vider le cache",
        cacheDownCleaned: "Le cache a été vidé",
        cleanCacheUp: "Supprimer toutes les modifications non synchronisées",
        cacheUpCleaned: "Toute les modifications non synchronisées ont étés supprimées",
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Fiches de récolement",
        "audits": "Projets de récolement",
        "thesaurusTerms": "Termes de thésaurus",
        "thesaurus": "Thésaurus",
        "entityFields": "Données système",
        "collaborators": "Collaborateurs",
        "authorities": "Autorités",
        "aliases": "Alias",
        "locations": "Localisations",
        "conditionReports": "Constats d'état",
        works: "Oeuvres",
        expressions: "Expressions",
        manifestations: "Manifestations",
      },
      "time": {
        "hours": "heure(s)",
        "minutes": "minute(s)",
        "seconds": "seconde(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Création d'un terme",
        "openButtonTitle": "Créer un terme",
        "createButton": "Valider",
        "anotherTermButton": "Valider et créer un autre terme",
        "cancelButton": "Annuler",
        "preferedTermLabel": "Terme préféré :",
        "synonymLabel": "Employé pour :",
        "genericTermPlaceholder": "Générique :",
        "selectSpecificLabel": "Sélectionner des termes spécifiques",
        disabledOffline: "La création d’un nouveau terme n’est pas disponible en usage hors-ligne de l’application",
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Création",
        errors: {
          searchError: "La recherche a échouée",
          fetchError: "Impossible de récupérer les termes de thésaurus"
        },
        "modalSearchInputPlaceholder": "Rechercher un terme",
        "selectionTabTitle": "Sélection",
        "thesaurusTermSelectorModalTitle": "Sélectionner un terme",
        "validate": "Valider"
      },
      "state": {
        "all": "Tous",
        "archived": "Archivé",
        "canceled": "Annulé",
        "finalized": "Terminé",
        "inPreparation": "En préparation",
        "inProgress": "En cours",
        "programmed": "Planifié",
        "toValidated": "À valider",
        "validated": "Validé",
        "aborted": "Interrompue",
        "success": "Terminée avec succès",
        "error": "Erreur",
        "none": "Aucune synchronisation précédente"
      }
    },
    "nl": {
      "actionBar": {
        "bar": {
          "inProgress": "Schetsen",
          "latest": "Gesloten rapporten / Rapporten gesloten"
        },
        "sideMenu": {
          "saveModifications": "Bewaar wijzigingen",
          "reportOverview": "Overzicht van het conditierapport",
          "signReport": "Onderteken conditierapport",
          "closeReport": "Sluit conditierapport",
          "printReport": "Druk conditierapport af",
          "deleteReport": "Verwijder huidig conditierapport",
          "deleteReportOfflineWarning": "Waarschuwing, dit element is niet gesynchroniseerd !",
          "deleteModificationsNotSynchronized": "Niet gesynchroniseerde wijzigingen verwijderen",
          "confirmDeletion": "Verwijdering bevestigen"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "De wijziging verwijderen",
          "changeAlterationTitle": "De titel van de wijziging wijzigen",
          "changeAlterationType": "Het type wijziging wijzigen",
          "titleModalHeader": "Bewerk de titel van de wijziging",
          "titleModalButton": "Bevestig"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Gebruikersnaam en/of paswoord niet correct",
            "network": "Communicatie met server mislukt"
          },
          "form": {
            "password": {
              "error": "Gelieve uw gebruikersnaam in te voeren",
              "label": "Paswoord"
            },
            "submit": "Inloggen",
            "submitting": "Aan het inloggen…",
            "username": {
              "error": "Gelieve uw paswoord in te voeren",
              "label": "Gebruikersnaam"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dit duurt langer dan gebruikelijk. Gelieve de toepassing niet te sluiten.",
          "spinner": "We brengen u terug online "
        }
      },
      cameraScanner: {
        scanCode: "Scan de streepjescode",
        cancel: "Annuleren",
      },
      "closeReportScreen": {
        "important": "BELANGRIJK",
        "close": "Sluit conditierapport",
        "title": "Sluit conditierapport",
        "notificationContent": "Het rapport '{referenceNumber}' werd gesloten",
        "warningMessage": "Eens gesloten kan het conditierapport niet meer gewijzigd of verwijderd worden",
        "warningQuestion": "Bent u zeker dat u het conditierapport wil sluiten?",
        "transferingFile": "Pdf-document aan het overzetten…",
        "fileGeneration": "Finale pdf wordt aangemaakt",
        "reportClosing": "Sluiten van het huidige conditierapport…"
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Soort beschadiging:",
          "alterationsTitle": "Beschadigingen: ",
          "createAlterationButtonLabel": "Beschadiging",
          "levelTitle": "Niveau 3",
          "precisionLabel": "Detail:",
          "deleteConfirmationMessage": "Bevestig schrapping van de schade",
          "precisionPlaceholder": "Selecteer subcategorie",
          "thesaurusTermWarningMessage": "De geselecteerde beschadiging komt niet overeen met de soort materiaal",
          "typeOfAlterationPlaceholder": "Selecteer soort observatie"
        },
        "annotation": {
          "annotationsTitle": "Annotatie",
          "commentsPlaceholder": "Verduidelijk",
          "deleteConfirmationMessage": "Bevestig schrapping?",
          "defaultImageConfirmationMessage": "Als standaardafbeelding instellen ?"
        },
        "defect": {
          "createElementButtonLabel": "Zone",
          "deleteConfirmationMessage": "Bevestig schrapping van de zone",
          "elementLabel": "Zone:",
          "precisionLabel": "Detail",
          "elementPlaceholder": "Naam van het element",
          "precisionPlaceholder": "Verduidelijk"
        },
        "material": {
          "createMaterialButtonLabel": "Materiaal",
          "deleteConfirmationMessage": "Bevestig schrapping van het materiaal",
          "levelTitle": "Niveau 2",
          "materialLabel": "Materiaal:",
          "materialsTitle": "Materialen:",
          "thesaurusTermWarningMessage": "Het geselecteerde materiaal komt niet overeen met het soort observatie"
        },
        "observation": {
          "createObservationButtonLabel": "Observatie",
          "deleteConfirmationMessage": "Bevestig schrapping van de observatie",
          "levelTitle": "Niveau 1",
          "observationLabel": "Soort observatie:",
          "observationsTitle": "Observaties:"
        },
        "submit": "Bewaar wijzigingen",
        "submitError": "De boomstructuur werd niet geüpdatet",
        "submitting": "Bewaren in verwerking…"
      },
      "drawingEditor": {
        "title": "Gedetailleerde beschadiging:",
        "imageTitlePlaceholder": "Soort beeldbijschrift/Voer beeldbijschrift in",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Selecteer een beschadiging",
        "observationPlaceholder": "Voer observatie in",
        "validate": "Bewaar",
        "errors": {
          "missingTitleOrType": "Voer een titel of type wijziging in voor elke wijziging"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Precisie",
            "validateButton": "Bevestig"
          },
          "titlePlaceHoder": "Titel van de wijziging...",
          "typeOfAlterationPlaceholder": "Type wijziging..."
        }
      },
      "editItemScreen": {
        "author": "Auteur",
        "confirmButton": "Bevestig",
        "editButton": "Aanpassen",
        "inventoryNumber": "Inventarisnummer",
        "saveNotification": {
          "errorMessage": "Er is een fout opgetreden bij het bewaren van het item",
          "inventoryNumberNotUnique": "Onmogelijke validatie",
          "successMessage": "Item succesvol bewaard"
        },
        "deleteNotification": {
          "errorMessage": "TRANSLATING IN PROGRESS",
          "successMessage": "TRANSLATING IN PROGRESS"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
          "successMessage": "De wijzigingen werden geannuleerd"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Dit inventarisnummer is al toegekend"
        },
        "menu": {
          "saveModifications": "Save modifications",
          "deleteNotSynchronizedNewItem": "TRANSLATING IN PROGRESS",
          "deleteModificationsNotSynchronized": "TRANSLATING IN PROGRESS",
          "offlineWarning": "Modifications are saved on this device, you will have to synchronize them with the database when the network is back.",
          "offlineShortWarning": "Modified on this device"
        },
        "fieldDisabledOffline": "Dit veld is niet beschikbaar in offline modus"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Rapportnummer {refNumber}",
        "reportStatusInProgress": "In verwerking",
        "reportIdentifiers": {
          "accordionPanelTitle": "ALGEMENE INFORMATIE",
          "referenceNumber": "Referentienummer",
          "numberingInformation": "Laat dit veld leeg om de automatische nummering te activeren van zodra het rapport is bewaard",
          "otherIdentifiers": "Andere identificatoren",
          "reportReason": "Reden conditierapport",
          "precision": "Detail",
          "reportType": "Rapporttype",
          "reportTypePlaceholder": "Selecteer een rapporttype",
          "tabTitle": "Identificatie"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXT",
          "reportDate": "Datum van het rapport",
          "reportDoneInThePresenceOf": "Rapport geschreven in aanwezigheid van",
          "andOf": "en",
          "name": "Familienaam / Voornaam, Rol/Functie",
          "role": "Rol/Functie",
          "coordinates": "Contactgegevens",
          "email": "E-mail",
          "signer": "Personen die gemachtigd zijn om het rapport te ondertekenen",
          "reportPlace": "Plaats",
          "customer": "Klant",
          "precisions": "Details",
          "linkedProject": "Gerelateerd project",
          "linkedMovement": "Gerelateerde verplaatsing",
          "technicsAndMaterials": "Technieken en materialen",
          "comments": "Opmerkingen"
        },
        "alterations": {
          "accordionPanelTitle": "BESCHADIGINGEN",
          "mediasSectionTitle": "afbeeldingsrapporten",
          "globalAlterationSectionTitle": "ALGEMENE SCHADE",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Aanmaken",
            "alterationTypeLabel": "Type schade",
            "precisionLabel": "Precisie"
          },
          "tabTitle": "Veranderingen",
          "viewMenu": {
            "alterationTypeView": "Weergeven op type wijziging",
            "imageView": "Foto bekijken",
            "titleView": "Weergeven op titel"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVATIE EN MANIPULATIE"
        },
        "observations": {
          "tabTitle": "Balans",
          "accordionPanelTitle": "ALGEMENE INFORMATIE & AANBEVELINGEN",
          "commentsFieldLabel": "Opmerkingen",
          "interventionToSchedule": "Geplande interventies",
          "interventionToSchedulePlaceholder": "Kies een interventie",
          "interventionToSchedulePrecision": "Detail :",
          "stateOfConservation": "Conservatiestaat",
          "stateOfConservationPlaceholder": "Kies een staat",
          "typeOfStateOfConservation": "Type status",
          "treatmentPriority": "Behandelprioriteit",
          "treatmentPriorityPlaceholder": "Kies een prioriteit"
        },
        "medias": {
          "accordionPanelTitle": "BIJGEVOEGDE MULTIMEDIA"
        },
        "saveAlert": {
          "errorMessage": "Error bij het bewaren van het conditierapport",
          "inventoryNumberNotUnique": "Onmogelijke validatie",
          "successMessage": "Conditierapport werd bewaard"
        },
        "deleteAlert": {
          "errorMessage": "Error bij het verwijderen van het conditierapport",
          "successMessage": "Conditierapport werd verwijderd"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Er is een fout opgetreden bij het verwijderen van niet-gesynchroniseerde wijzigingen",
          "successMessage": "De wijzigingen werden geannuleerd"
        },
        "fieldDisabledOffline": "Dit veld is niet beschikbaar in offline modus"
      },
      "editRecordScreen": {
        "foldAll": "Verminder alle",
        "unfoldAll": "Zet alle",
        "medias": {
          "accordionPanelTitle": "BIJGEVOEGDE MULTIMEDIA"
        }
      },
      "itemCreationImagePopup": {
        "title": "Een afbeelding toevoegen",
        "addImage": "EEN AFBEELDING TOEVOEGEN",
        "ignore": "LATER, NEGEER DEZE STAP"
      },
      "itemSearchScreen": {
        "createNewItem": "NIEUW ITEM MAKEN"
      },
      "firewall": {
        "collabWarningMessage": "Er is geen medewerker gelinkt aan uw account, de toepassing kan minder goed werken",
        "noGroupForUserWarningMessage": "Om SKIN-reporter te kunnen gebruiken moet uw gebruikersaccount gelinkt zijn aan een gebruikersgroep"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Error bij het downloaden van het document",
          "downloadSuccess": "Het document {docTitle} werd gedownload",
          "open": "Document openen",
          "title": "Afgewerkte conditierapporten"
        },
        "inProgress": {
          "edit": "BEWERK CONDITIERAPPORT",
          "title": "Schetsen"
        },
        "concernedItem": "Gerelateerde objecten",
        "nbResults": "{nbResults} Resultaten",
        "noResults": "Geen resultaten"
      },
      "locationSelector": {
        "inputPlaceholder": "Soort locatie",
        "title": "Selecteer locatie",
        "validate": "Valideer"
      },
      "maskFields": {
        "boolean": {
          "no": "Nee",
          "undefined": "Ongedefinieerd",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Trefwoorden of identificatoren"
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Ingezet/Ontwikkeld op:",
          "checkForUpdate": {
            "help": "Als een update beschikbaar is, zal die automatisch worden geïnstalleerd.",
            "title": "Gelieve te controleren op updates"
          },
          "clearCache": {
            "help": "Als u offline bent, heeft u niet langer toegang tot alle gegevens die op uw toestel zijn opgeslagen.",
            "title": "Maak cache (tijdelijk geheugen) leeg"
          },
          "overrideLocale": {
            "help": "Het Engels zal worden gebruikt en de instellingen van uw apparaat zullen worden genegeerd.",
            "title": "Het Engels forceren"
          },
          "resetLocaleOverride": {
            "help": "De gebruikte taal zal afhangen van de instellingen van uw terminal",
            "title": "Stel taal opnieuw in"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Bent u zeker dat u wil uitloggen?"
      },
      "offlineRibbon": {
        "offline": "U bent nu offline",
        "online": "U bent nu online"
      },
      "pdfOverviewScreen": {
        "download": "Download",
        "progressBar": {
          "mainLabel": "Document wordt voorbereid",
          "object": "Object",
          "generalDigest": "Algemene informatie",
          "defects": "Beschadiging",
          "contextAndSignatures": "Context en handtekeningen",
          "documentReady": "Document is klaar!"
        },
        "title": "Overzicht",
        "renderFailureAlert": "PDF kan niet worden gemaakt, probeer het opnieuw"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITIERAPPORT - ",
        "objectSection": {
          "sectionTitle": "Object",
          "inventoryNumber": "Inventarisnummer:",
          "title": "Titel:",
          "author": "Kunstenaar / Auteur:",
          "creationDate": "Aanmaakdatum:",
          "typology": "Typologie:",
          "denomination": "Benaming:",
          "materialsAndTechniques": "Materialen en technieken:",
          "dimensions": "Afmetingen:",
          "institution": "Instelling:"
        },
        "alterationsSection": {
          "detailedAlteration": "Details van de beschadiging",
          "noAnnotation": "Geen annotatie om te tonen",
          "observationLabel": "Obs.",
          "sectionTitle": "Details van de beschadigingen"
        },
        "finalObservationsSection": {
          "sectionTitle": "Finale observaties"
        },
        "contextSection": {
          "comments": "Opmerkingen:",
          "matAndTechs": "Materialen en technieken:",
          "reportDate": "Datum van het rapport:",
          "reportPlace": "Plaats van het rapport:",
          "reportReference": "Rapportreferentie:",
          "sectionTitle": "Context",
          "reportType": "Rapporttype:",
          "reportReason": "Reden conditierapport:"
        },
        "reportSection": {
          "interventionsToSchedule": "Interventies om in te plannen:",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Rapport opgemaakt in aanwezigheid van:",
          "stateOfConservation": "Conservatiestaat",
          "treatmentPriority": "Behandelprioriteit:"
        },
        "footer": {
          "prefix": "CONDITIERAPPORT",
          "separator": " - Pagina"
        },
        "generationFailureAlert": "PDF genereren mislukt, probeer opnieuw"
      },
      "proxy": {
        "error": {
          "default": "Error bij de hulpbron {uri}",
          "network": "Communicatie met server mislukt",
          "notFound": "De oplossing {uri} kon niet worden gevonden",
          "tokenHasExpired": "Uw sessie is vervallen"
        }
      },
      "search": {
        "noResults": "Geen resultaten",
        "options": {
          "sortType": {
            "creationDate": "Aanmaakdatum",
            "identifier": "Hoofdidentificator",
            "lastModification": "Laatste wijziging",
            "mainTitle": "Hoofdtitel",
            "referenceNumber": "Referentienummer"
          }
        },
        "queryPlaceholder": "Zoekopdracht",
        "title": "Objecten",
        "totalCount": "{totalResults}  Resulta(a)t(en) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "MAAK NIEUW CONDITIERAPPORT AAN",
        "createNewReportFromLast": "MAAK CONDITIERAPPORT AAN OP BASIS VAN HET LAATSTE RAPPORT",
        "institutionLabel": "Instelling",
        "lastReportLabel": "Laatste conditierapport",
        "materialsAndTechniques": "Materialen / Technieken",
        "measurements": "Afmetingen",
        "noLinkedItem": "Er is geen item gelinkt aan dit conditierapport"
      },
      "serviceWorker": {
        "updateAvailable": "Update werd geïnstalleerd. U kunt ofwel hier klikken om de pagina te vernieuwen ofwel de toepassing opnieuw opstarten"
      },
      "signatureModuleScreen": {
        "cardTitle": "Ondertekenaar",
        "eraseSignature": "Haal handtekening weg",
        "missingSignature": "Het conditierapport werd niet ondertekend",
        "nameLabel": "Familienaam / Voornaam",
        "presentSignature": "Het conditierapport werd ondertekend",
        "saveSignature": "Bewaar",
        "signatureStatus": "Status/Statuut van de handtekening",
        "title": "Handtekeningen"
      },
      "synchroModal": {
        "title": "Synchronisatie",
        "lastFetch": "Laatste recuperatie",
        "duration": "Duur",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "Laaste synchronisatie",
        "noEntityToSync": "Niks om te synchroniseren",
        "connectionWarningPrefix": "U moet verbonden zijn met het internet om te",
        "connectWarningSend": "verzenden",
        "connectWarningRetrieve": "haal terug",
        "connectionWarningSuffix": "gegevens",
        "noDataToSync": "Geen gegevens om te synchroniseren op dit ogenblik",
        "localIconInfoPrefix": "Het icoon",
        "localIconInfoSuffix": " geeft aan dat de corresponderende gegevens lokaal zijn gewijzigd en moeten worden gesynchroniseerd met de databank.",
        "retrieveAll": "haal alles terug",
        "finishedSynchros": "Synchronisatie beëindigd",
        "syncAll": "Alles synchroniseren",
        "remainsToSynchronize": "Nog te synchroniseren",
        "cleanImageCache": "Spookafbeeldingen uit de cache verwijderen",
        "cachedImagedCleaned": "De spookbeelden zijn verwijderd!",
        "cleanCacheDown": "De cache wissen",
        "cacheDownCleaned": "De cache is geleegd!",
        "cleanCacheUp": "Alle niet gesynchroniseerde wijzigingen verwijderen",
        "cacheUpCleaned": "Alle niet gesynchroniseerde wijzigingen zijn verwijderd!"
      },
      "entityNames": {
        "items": "Items",
        "auditRecords": "Inventarisfiches",
        "audits": "Inventariscampagnes",
        "thesaurusTerms": "Thesaurusitems",
        "thesaurus": "Thesaurus",
        "entityFields": "Systeemgegevens",
        "collaborators": "Medewerkers",
        "authorities": "Autoriteiten",
        "aliases": "Aliassen",
        "locations": "Locaties",
        "conditionReports": "Conditierapporten",
        "works": "Werken",
        "expressions": "Expressies",
        "manifestations": "Verschijningsvormen"
      },
      "time": {
        "hours": "uur/uren",
        "minutes": "minuut/minuten",
        "seconds": "seconde(n)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Termijn aanmaken",
        "openButtonTitle": "Termijn aanmaken",
        "createButton": "Bevestig",
        "anotherTermButton": "Bevestigen en andere termijn aanmaken",
        "cancelButton": "Annuleren",
        "preferedTermLabel": "Voorkeur term ",
        "synonymLabel": "Gebruikt voor",
        "genericTermPlaceholder": "Algemeen",
        "selectSpecificLabel": "Specifieke termen selecteren",
        "disabledOffline": "Een thesaurusTerm aanmaken terwijl u offline bent, is niet toegestaan"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Aanmaken",
        errors: {
          searchError: "De zoektocht was niet succesvol",
          fetchError: "Kan thesaurustermen niet ophalen"
        },
        "modalSearchInputPlaceholder": "Een term onderzoeken",
        "selectionTabTitle": "Selectie",
        "thesaurusTermSelectorModalTitle": "Selecteer een term",
        "validate": "Valideren"
      },
      "state": {
        "all": "Alle",
        "archived": "Gearchiveerd",
        "canceled": "Geannuleerd",
        "finalized": "Beëindigd",
        "inPreparation": "In voorbereiding",
        "inProgress": "In uitvoering",
        "programmed": "Gepland",
        "toValidated": "Moet worden gevalideerd",
        "validated": "Gevalideerd",
        "aborted": "Afgebroken",
        "success": "Succesvol beëindigd",
        "error": "Fout",
        "none": "Geen voorgaande synchronisatie"
      }
    },
    "es": {
      "actionBar": {
        "bar": {
          "inProgress": "En curso",
          "latest": "Completado"
        },
        "sideMenu": {
          "saveModifications": "Salvaguardar los cambios",
          "reportOverview": "Resumen del informe de estado",
          "signReport": "Firmar el informe de estado",
          "closeReport": "Cerrar el informe de condiciones",
          "printReport": "Imprimir el informe de estado",
          "deleteReport": "Eliminar el informe actual",
          "deleteReportOfflineWarning": "Tenga en cuenta que este elemento no está sincronizado.",
          "deleteModificationsNotSynchronized": "Borrar cambios no sincronizados",
          "confirmDeletion": "Confirmar eliminación"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Eliminar la alteración",
          "changeAlterationTitle": "Cambiar el título de la modificación",
          "changeAlterationType": "Cambiar el tipo de modificación",
          "titleModalHeader": "Editar el título de la modificación",
          "titleModalButton": "Confirme"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Sus datos de acceso son incorrectos",
            "network": "La comunicación con el servidor ha fallado"
          },
          "form": {
            "password": {
              "error": "Por favor, introduzca su nombre de usuario",
              "label": "Contraseña"
            },
            "submit": "Entrar en el sistema",
            "submitting": "Conectando...",
            "username": {
              "error": "Por favor, introduzca su contraseña",
              "label": "Nombre de usuario"
            }
          }
        },
        "renew": {
          "slowNetwork": "Si parece que tarda más de lo habitual, no abandones la aplicación.",
          "spinner": "Le reconectamos..."
        }
      },
      cameraScanner: {
        scanCode: "Escanear el código de barras",
        cancel: "Cancelar",
      },
      "closeReportScreen": {
        "important": "IMPORTANTE",
        "close": "Cerrar",
        "title": "Cierre del informe de situación",
        "notificationContent": "El informe '{referenceNumber}' ha sido cerrado",
        "warningMessage": "Un informe cerrado no puede modificarse ni borrarse",
        "warningQuestion": "¿Realmente quiere perseguir el cierre del informe de condiciones?",
        "transferingFile": "Transferir el documento PDF...",
        "fileGeneration": "Generación del documento pdf final...",
        "reportClosing": "El cierre del informe estado..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Tipo:",
          "alterationsTitle": "Alteraciones :",
          "createAlterationButtonLabel": "Alteración",
          "levelTitle": "Nivel 3",
          "precisionLabel": "Aclaración:",
          "deleteConfirmationMessage": "¿Confirmar la supresión de la alteración y su contenido?",
          "precisionPlaceholder": "Seleccione un subtipo",
          "thesaurusTermWarningMessage": "El tipo de alteraciónseleccionado no coincide con el material anterior",
          "typeOfAlterationPlaceholder": "Seleccione un tipo de observación"
        },
        "annotation": {
          "annotationsTitle": "Anotaciones :",
          "commentsPlaceholder": "Especifica...",
          "deleteConfirmationMessage": "¿Confirmar el borrado?",
          "defaultImageConfirmationMessage": "¿Fijar como imagen por defecto?"
        },
        "defect": {
          "createElementButtonLabel": "Elemento",
          "deleteConfirmationMessage": "¿Confirmar la eliminación del elemento y su contenido?",
          "elementLabel": "Elemento:",
          "precisionLabel": "Precisión",
          "elementPlaceholder": "Nombre del elemento",
          "precisionPlaceholder": "Especifica..."
        },
        "material": {
          "createMaterialButtonLabel": "Material",
          "deleteConfirmationMessage": "¿Confirmar la supresión del material y su contenido?",
          "levelTitle": "Nivel 2",
          "materialLabel": "Material:",
          "materialsTitle": "Materiales :",
          "thesaurusTermWarningMessage": "El material seleccionado no coincide con el tipo de observación anterior"
        },
        "observation": {
          "createObservationButtonLabel": "Observación",
          "deleteConfirmationMessage": "¿Confirmar la supresión del comentario y su contenido?",
          "levelTitle": "Nivel 1",
          "observationLabel": "Tipo de observación :",
          "observationsTitle": "Observaciones:"
        },
        "submit": "Guardar los cambios",
        "submitError": "El árbol no ha podido ser actualizado",
        "submitting": "Copia de seguridad en curso..."
      },
      "drawingEditor": {
        "title": "Alteración detallada",
        "imageTitlePlaceholder": "Introduzca el título de la imagen",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Seleccionar una modificación",
        "observationPlaceholder": "Introduzca un comentario",
        "validate": "Salvaguardar",
        "errors": {
          "missingTitleOrType": "Introduzca un título o tipo de modificación para cada modificación"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Precisión",
            "validateButton": "Confirme"
          },
          "titlePlaceHoder": "Título de la modificación...",
          "typeOfAlterationPlaceholder": "Tipo de modificación..."
        }
      },
      "editItemScreen": {
        "author": "Autor",
        "confirmButton": "Confirmar",
        "editButton": "Modifique",
        "inventoryNumber": "Número de inventario",
        "saveNotification": {
          "errorMessage": "Se ha producido un error al guardar el objeto",
          "inventoryNumberNotUnique": "No se puede validar, el número de identificación del registro ya existe",
          "successMessage": "El objeto se ha guardado con éxito"
        },
        "deleteNotification": {
          "errorMessage": "Se ha producido un error al borrar el objeto no sincronizado",
          "successMessage": "El objeto se ha borrado con éxito"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Se ha producido un error al borrar los cambios no sincronizado",
          "successMessage": "Los cambios han sido cancelados"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Este número de inventario ya ha sido asignado"
        },
        "menu": {
          "saveModifications": "Guardar los cambios",
          "deleteNotSynchronizedNewItem": "Eliminar el nuevo objeto",
          "deleteModificationsNotSynchronized": "Eliminar las modificaciones no sincronizadas",
          "offlineWarning": "Los cambios se guardan en el dispositivo, tendrá que sincronizarlos con la base de datos cuando la red vuelva a estar disponible.",
          "offlineShortWarning": "Modificado en este dispositivo"
        },
        "fieldDisabledOffline": "Este campo no está disponible en modo fuera de línea"
      },
      "editReportScreen": {
        "reportTitlePrefix": "Informe nº {refNumber}",
        "reportStatusInProgress": "En curso",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFICADORES DE INFORMES",
          "referenceNumber": "Número de referencia",
          "numberingInformation": "Dejar en blanco para activar la marcación automática en el siguiente guardado",
          "otherIdentifiers": "Otros identificadores",
          "reportReason": "Motivo del informe",
          "precision": "Precisión",
          "reportType": "Tipo de hallazgo",
          "reportTypePlaceholder": "Seleccione un tipo de informe",
          "tabTitle": "Identificación"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTEXTO DEL INFORME DE ESTADO",
          "reportDate": "Fecha del informe",
          "reportDoneInThePresenceOf": "Observación realizada en presencia de",
          "andOf": "Y de",
          "name": "Apellidos/Nombre, Cargo",
          "role": "Calidad",
          "coordinates": "Datos de contacto",
          "email": "Direccion electrónica",
          "signer": "Firmante",
          "reportPlace": "Localización del informe",
          "customer": "Cliente/Comprador",
          "precisions": "Detalles",
          "linkedProject": "Proyecto relacionado",
          "linkedMovement": "Movimiento vinculado",
          "technicsAndMaterials": "Técnicas y materiales utilizados",
          "comments": "Comentarios"
        },
        "alterations": {
          "accordionPanelTitle": "ALTERACIONES",
          "mediasSectionTitle": "IMÁGENES DEL INFORME",
          "globalAlterationSectionTitle": "ALTERACIONES GENERALES",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Crear",
            "alterationTypeLabel": "Tipo de modificación",
            "precisionLabel": "Precisión"
          },
          "tabTitle": "Alteraciones",
          "viewMenu": {
            "alterationTypeView": "Ver por tipo de modificación",
            "imageView": "Ver foto",
            "titleView": "Ver por título"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVACIÓN Y MANIPULACIÓN"
        },
        "observations": {
          "tabTitle": "Balance",
          "accordionPanelTitle": "INFORME Y COMENTARIOS",
          "commentsFieldLabel": "Comentarios",
          "interventionToSchedule": "Intervenciones a planificar",
          "interventionToSchedulePlaceholder": "Elija una intervención",
          "interventionToSchedulePrecision": "Aclaración:",
          "stateOfConservation": "Estado del inmueble",
          "stateOfConservationPlaceholder": "Elija un estado",
          "typeOfStateOfConservation": "Tipo de estado",
          "treatmentPriority": "Prioridad de tratamiento",
          "treatmentPriorityPlaceholder": "Elija una prioridad"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Se ha producido un error al guardar el informe",
          "inventoryNumberNotUnique": "No se puede validar, el número de identificación del registro ya existe",
          "successMessage": "Informe de estado guardado"
        },
        "deleteAlert": {
          "errorMessage": "Se ha producido un error al borrar el informe",
          "successMessage": "Informe de estado borrado"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Se ha producido un error al borrar los cambios no sincronizado",
          "successMessage": "Los cambios han sido cancelados"
        },
        "fieldDisabledOffline": "Este campo no está disponible en modo offline"
      },
      "editRecordScreen": {
        "foldAll": "Reducir todo",
        "unfoldAll": "Desplegar todo",
        "medias": {
          "accordionPanelTitle": "MEDIA"
        }
      },
      "firewall": {
        "collabWarningMessage": "Su cuenta no tiene un colaborador asociado, la aplicación puede funcionar mal",
        "noGroupForUserWarningMessage": "El uso de SKINreporter requiere que su cuenta de usuario esté vinculada a un grupo de usuarios"
      },
      "itemCreationImagePopup": {
        "title": "Añadir una imagen",
        "addImage": "AÑADIR UNA IMAGEN",
        "ignore": "MÁS TARDE, OMITA ESTE PASO"
      },
      "itemSearchScreen": {
        "createNewItem": "CREAR UN NUEVO OBJETO"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Se ha producido un error durante la descarga",
          "downloadSuccess": "El documento {docTitle} ha sido descargado",
          "open": "DESCARGAR EL DOCUMENTO",
          "title": "Informes de estado completados"
        },
        "inProgress": {
          "edit": "EDITAR EL INFORME",
          "title": "Informes de estado que se emiten"
        },
        "concernedItem": "Objeto del museo en cuestión",
        "nbResults": "{nbResults} resultados",
        "noResults": "No hay resultados"
      },
      "locationSelector": {
        "inputPlaceholder": "Introduzca una ubicación",
        "title": "Elija una ubicación",
        "validate": "Validar"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "No definido",
          "yes": "Sí"
        },
        "entitySelect": {
          "modalPlaceholder": "Palabras clave o identificadores..."
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Desplegado en",
          "checkForUpdate": {
            "help": "Si hay una actualización disponible, se instalará automáticamente.",
            "title": "Comprobar las actualizaciones"
          },
          "clearCache": {
            "help": "Si estás sin conexión, esto elimina el acceso a todos los datos almacenados en el dispositivo.",
            "title": "Vaciar la caché"
          },
          "overrideLocale": {
            "help": "Se utilizará el idioma inglés y se ignorará la configuración de su terminal.",
            "title": "Forzar el idioma inglés"
          },
          "resetLocaleOverride": {
            "help": "El idioma utilizado dependerá de la configuración de su terminal",
            "title": "Restablecer el idioma"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "¿Está seguro de que quiere desconectarte?"
      },
      "offlineRibbon": {
        "offline": "Usted está fuera de línea",
        "online": "Está conectado"
      },
      "pdfOverviewScreen": {
        "download": "Descargar",
        "progressBar": {
          "mainLabel": "Generación de documentos ...",
          "object": "Objeto",
          "generalDigest": "Apreciación general",
          "defects": "Alteraciones",
          "contextAndSignatures": "Antecedentes y firmas",
          "documentReady": "¡Documento listo!"
        },
        "title": "Resumen",
        "renderFailureAlert": "No se puede mostrar el PDF, inténtelo de nuevo más tarde"
      },
      "pdfDocument": {
        "mainTitlePrefix": "INFORME DE ESTADO - ",
        "objectSection": {
          "sectionTitle": "Objeto",
          "inventoryNumber": "Nº de inventario : ",
          "title": "Título: ",
          "author": "Artista / Autor :",
          "creationDate": "Fecha de creación : ",
          "typology": "Tipología: ",
          "denomination": "Nombre: ",
          "materialsAndTechniques": "Materiales y técnicas :",
          "dimensions": "Dimensiones: ",
          "institution": "Institución:"
        },
        "alterationsSection": {
          "detailedAlteration": "Alteración detallada",
          "noAnnotation": "No hay anotaciones que mostrar",
          "observationLabel": "Obs.",
          "sectionTitle": "Detalles de las alteraciones"
        },
        "finalObservationsSection": {
          "sectionTitle": "Observaciones finales"
        },
        "contextSection": {
          "comments": "Comentarios :",
          "matAndTechs": "Materiales y técnicas :",
          "reportDate": "Fecha del hallazgo :",
          "reportPlace": "Ubicación: ",
          "reportReference": "Referencia del informe :",
          "sectionTitle": "Antecedentes de este informe de situación",
          "reportType": "Tipo de hallazgo : ",
          "reportReason": "Motivo del hallazgo: "
        },
        "reportSection": {
          "interventionsToSchedule": "Intervenciones a planificar : ",
          "sectionTitle": "Informe",
          "signatoriesTitle": "Observación realizada en presencia de :",
          "stateOfConservation": "Estado de la propiedad: ",
          "treatmentPriority": "Prioridad de tratamiento : "
        },
        "footer": {
          "prefix": "DECLARACIÓN DE CONDICIONES",
          "separator": "- Página"
        },
        "generationFailureAlert": "Error en la generación del PDF, inténtelo de nuevo más tarde"
      },
      "proxy": {
        "error": {
          "default": "Se ha producido un error en el recurso {uri}",
          "network": "La comunicación con el servidor ha fallado",
          "notFound": "No se ha encontrado el recurso {uri}",
          "tokenHasExpired": "Su sesión ha expirado"
        }
      },
      "search": {
        "noResults": "No hay resultados",
        "options": {
          "sortType": {
            "creationDate": "Fecha de creación",
            "identifier": "Identificador principal",
            "lastModification": "Última modificación",
            "mainTitle": "Título principal",
            "referenceNumber": "Número de referencia"
          }
        },
        "queryPlaceholder": "Palabras clave o número de inventario",
        "title": "Objetos de museo",
        "totalCount": "{totalResults} Resultado(s) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "CREAR UNA NUEVO INFORME",
        "createNewReportFromLast": "DECLARACIÓN DEL ÚLTIMO INFORME",
        "institutionLabel": "Institución",
        "lastReportLabel": "Último informe de estado",
        "materialsAndTechniques": "Materiales / Técnicas",
        "measurements": "Dimensiones",
        "noLinkedItem": "No hay artículos relacionados con este informe de estado"
      },
      "serviceWorker": {
        "updateAvailable": "Se ha instalado una actualización. Pulse aquí para recargar la página o reiniciar la aplicación"
      },
      "signatureModuleScreen": {
        "cardTitle": "Firmante",
        "eraseSignature": "Firma de nuevo",
        "missingSignature": "Falta la firma",
        "nameLabel": "Apellido / Nombre",
        "presentSignature": "Firma presente",
        "saveSignature": "Registro",
        "signatureStatus": "Estado de la firma",
        "title": "Firmas"
      },
      "synchroModal": {
        "title": "Sincronización",
        "lastFetch": "Última recuperación",
        "duration": "Duración",
        "status": "Estado",
        "details": "Detalles",
        "lastSynchro": "Última sincronización",
        "noEntityToSync": "No hay entidades que sincronizar",
        "connectionWarningPrefix": "Debe estar conectado al Internet para poder",
        "connectWarningSend": "enviar",
        "connectWarningRetrieve": "recuperar",
        "connectionWarningSuffix": "datos",
        "noDataToSync": "No hay datos que sincronizar por el momento",
        "localIconInfoPrefix": "El icono",
        "localIconInfoSuffix": " indica que los datos correspondientes han sido modificados localmente y tendrán que ser sincronizados con la base de datos remota.",
        "retrieveAll": "Recuperar todo",
        "finishedSynchros": "sincronizaciones completadas",
        "syncAll": "Sincronizar todo",
        "remainsToSynchronize": "Restos por sincronizar",
        "cleanImageCache": "Eliminar imágenes fantasma de la cache",
        "cachedImagedCleaned": "Se han eliminado las imágenes fantasma",
        "cleanCacheDown": "Borrar la cache",
        "cacheDownCleaned": "Se ha vaciado la cache",
        "cleanCacheUp": "Borrar todos los cambios no sincronizados",
        "cacheUpCleaned": "Se han eliminado todos los cambios no sincronizados"
      },
      "entityNames": {
        "items": "Artículos",
        "auditRecords": "Hojas de recogida",
        "audits": "Proyectos de reconstrucción",
        "thesaurusTerms": "Términos del tesauro",
        "thesaurus": "Tesauro",
        "entityFields": "Datos del sistema",
        "collaborators": "Personal",
        "authorities": "Autoridades",
        "aliases": "Alias",
        "locations": "Ubicaciones",
        "conditionReports": "Informes de estado",
        "works": "Obras",
        "expressions": "Expresiones",
        "manifestations": "Manifestaciones"
      },
      "time": {
        "hours": "hora(s)",
        "minutes": "minuto(s)",
        "seconds": "segundo(s)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Crear un término",
        "openButtonTitle": "Crear un término",
        "createButton": "Validar",
        "anotherTermButton": "Validar y crear otro término",
        "cancelButton": "Cancelar",
        "preferedTermLabel": "Término preferido :",
        "synonymLabel": "Utilizado para :",
        "genericTermPlaceholder": "Genérico :",
        "selectSpecificLabel": "Seleccionar términos específicos",
        "disabledOffline": "La creación de un nuevo término no está disponible cuando se utiliza la aplicación sin conexión."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Crear",
        errors: {
          searchError: "La búsqueda fue infructuosa",
          fetchError: "No se pueden recuperar los términos del tesauro"
        },
        "modalSearchInputPlaceholder": "Buscar un término",
        "selectionTabTitle": "Seleccione",
        "thesaurusTermSelectorModalTitle": "Seleccione un término",
        "validate": "Confirme"
      },
      "state": {
        "all": "Todos",
        "archived": "Archivado",
        "canceled": "Cancelado",
        "finalized": "Completado",
        "inPreparation": "En preparación",
        "inProgress": "En proceso",
        "programmed": "Planificado",
        "toValidated": "Por validar",
        "validated": "Validado",
        "aborted": "Interrumpido",
        "success": "Completado con éxito",
        "error": "Error",
        "none": "No hay sincronización previa"
      }
    },
    "it": {
      "actionBar": {
        "bar": {
          "inProgress": "In corso",
          "latest": "Completato"
        },
        "sideMenu": {
          "saveModifications": "Salvare le modifiche",
          "reportOverview": "Panoramica del report sulle condizioni",
          "signReport": "Firmare il condition report",
          "closeReport": "Chiudere il condition report",
          "printReport": "Stampare il condition report",
          "deleteReport": "Eliminare il condition report corrente",
          "deleteReportOfflineWarning": "Si prega di notare che questo elemento non è sincronizzato!",
          "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
          "confirmDeletion": "Confermare l'eliminazione"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Eliminare l’alterazione",
          "changeAlterationTitle": "Modificare il titolo dell’alterazione",
          "changeAlterationType": "Modificare il tipo d’alterazione",
          "titleModalHeader": "Modificare il titolo dell’alterzione",
          "titleModalButton": "Confermare"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Le sue credenziali non sono corrette",
            "network": "Comunicazione con il server fallita"
          },
          "form": {
            "password": {
              "error": "Per favore",
              "label": "Password"
            },
            "submit": "Per accedere",
            "submitting": "Login...",
            "username": {
              "error": "Inserisce il password",
              "label": "Nome dell’utente"
            }
          }
        },
        "renew": {
          "slowNetwork": "Sembra che ci stia impiegando più tempo del solito, non esca dall'app.",
          "spinner": "Le ricolleghiamo..."
        }
      },
      cameraScanner: {
        scanCode: "Scannerizzare il codice",
        cancel: "Annullare",
      },
      "closeReportScreen": {
        "important": "IMPORTANTE",
        "close": "Avvolgere",
        "title": "Chiusura del condition report",
        "notificationContent": "Il rapporto '{referenceNumber}' è stato chiuso",
        "warningMessage": "Un rapporto chiuso non può essere modificato o eliminato",
        "warningQuestion": "Vuole davvero continuare a chiudere il condition report ?",
        "transferingFile": "Trasferimento del documento PDF...",
        "fileGeneration": "Generazione del documento pdf finale...",
        "reportClosing": "Chiusura del condition report…"
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Tipo :",
          "alterationsTitle": "Alterazioni:",
          "createAlterationButtonLabel": "Alterazione",
          "levelTitle": "Livello 3",
          "precisionLabel": "Precisione:",
          "deleteConfirmationMessage": "Conferma l'eliminazione della modifica e del suo contenuto?",
          "precisionPlaceholder": "Seleziona un sottotipo",
          "thesaurusTermWarningMessage": "Il tipo d’alterazione selezionato non corrisponde al materiale sopra",
          "typeOfAlterationPlaceholder": "Seleziona un tipo di osservazione"
        },
        "annotation": {
          "annotationsTitle": "Annotazioni",
          "commentsPlaceholder": "Specificare...",
          "deleteConfirmationMessage": "Confermare la cancellazione?",
          "defaultImageConfirmationMessage": "Impostare come immagine predefinita?"
        },
        "defect": {
          "createElementButtonLabel": "Elemento",
          "deleteConfirmationMessage": "Conferma l'eliminazione dell'elemento e del suo contenuto?",
          "elementLabel": "Elemento :",
          "precisionLabel": "Precisione",
          "elementPlaceholder": "Nome dell'oggetto",
          "precisionPlaceholder": "Specifica.."
        },
        "material": {
          "createMaterialButtonLabel": "Materiali",
          "deleteConfirmationMessage": "Conferma la cancellazione del materiale e del suo contenuto?",
          "levelTitle": "Livello 2",
          "materialLabel": "Materiale ",
          "materialsTitle": "Materiale ",
          "thesaurusTermWarningMessage": "Il materiale selezionato non corrisponde al tipo di osservazione di cui sopra."
        },
        "observation": {
          "createObservationButtonLabel": "Osservazione",
          "deleteConfirmationMessage": "Confermare la cancellazione dell'osservazione e del suo contenuto?",
          "levelTitle": "Livello 1",
          "observationLabel": "Tipo di osservazione ",
          "observationsTitle": "Osservazione "
        },
        "submit": "Salva le modifiche",
        "submitError": "Non è stato possibile aggiornare l'albero",
        "submitting": "Salvataggio in corso..."
      },
      "drawingEditor": {
        "title": "Modifica dettagliata",
        "imageTitlePlaceholder": "Inserire la didascalia dell'immagine",
        "observationLabel": "Obs {index}",
        "observationPlaceholder": "Inserire un'osservazione",
        "validate": "Salvare",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Selezionare una modifica",
        "errors": {
          "missingTitleOrType": "Inserire un titolo o un tipo di modifica per ciascuna alterazione"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Precisioni",
            "validateButton": "Confermare"
          },
          "titlePlaceHoder": "Titolo dell’alterazione",
          "typeOfAlterationPlaceholder": "Tipo di alterazione"
        }
      },
      "editReportScreen": {
        "reportTitlePrefix": "Numero di osservazione {refNumber}",
        "reportStatusInProgress": "In corso",
        "reportIdentifiers": {
          "accordionPanelTitle": "IDENTIFICATORI DI OSSERVAZIONE",
          "referenceNumber": "Numero di riferimento",
          "numberingInformation": "Lasciare vuoto per attivare la numerazione automatica alla prossima memorizzazione.",
          "otherIdentifiers": "Altri identificatori",
          "reportReason": "Motivo del rapporto",
          "precision": "Precisione",
          "reportType": "Tipo di rapporto",
          "reportTypePlaceholder": "Selezionare un tipo di condition report",
          "tabTitle": "Identificazione"
        },
        "reportContext": {
          "accordionPanelTitle": "CONTESTO DEL RAPPORTO SULLE CONDIZIONI",
          "reportDate": "Data del condition report",
          "reportDoneInThePresenceOf": "Condition report redatto in presenza di",
          "andOf": "E di",
          "name": "Cognome/Nome, Posizione",
          "role": "Qualità",
          "coordinates": "Dettagli di contatto",
          "email": "Email",
          "signer": "Firmatario",
          "reportPlace": "Luogo del condition report",
          "customer": "Cliente",
          "precisions": "Dettagli",
          "linkedProject": "Progetto correlato",
          "linkedMovement": "Movimento collegato",
          "technicsAndMaterials": "Tecniche e materiali utilizzati",
          "comments": "Commenti"
        },
        "alterations": {
          "accordionPanelTitle": "ALTERAZIONI",
          "mediasSectionTitle": "RAPPORTO IMMAGINI",
          "globalAlterationSectionTitle": "ALTERAZIONI GENERALI",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Creare",
            "alterationTypeLabel": "Tipo di alterazione",
            "precisionLabel": "Precisione"
          },
          "tabTitle": "Alterazioni",
          "viewMenu": {
            "alterationTypeView": "Vista per tipo di alterazione",
            "imageView": "Vista foto",
            "titleView": "Vista per titolo"
          }
        },
        "conservation": {
          "accordionPanelTitle": "CONSERVAZIONE E MANIPOLAZIONE"
        },
        "observations": {
          "tabTitle": "Bilancio",
          "accordionPanelTitle": "RELAZIONI E OSSERVAZIONI",
          "commentsFieldLabel": "Commenti",
          "interventionToSchedule": "Interventi da pianificare",
          "interventionToSchedulePlaceholder": "Scegliere un intervento",
          "interventionToSchedulePrecision": "Precisione ",
          "stateOfConservation": "Condizioni dell'oggetto",
          "stateOfConservationPlaceholder": "Scegliere uno stato",
          "typeOfStateOfConservation": "Tipo di stato",
          "treatmentPriority": "Priorità di trattamento",
          "treatmentPriorityPlaceholder": "Scegliere una priorità"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Si è verificato un errore durante il salvataggio del rapporto",
          "successMessage": "Condition report salvato",
          "inventoryNumberNotUnique": "Non può essere convalidato, il numero di identificazione del record esiste già."
        },
        "deleteAlert": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione del condition report",
          "successMessage": "Condition report cancellato"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
          "successMessage": "Le modifiche sono state annullate"
        },
        "fieldDisabledOffline": "Questo campo non è disponibile in modalità offline"
      },
      "firewall": {
        "collabWarningMessage": "Se il vostro account non ha un collaboratore associato, l'applicazione potrebbe non funzionare correttamente.",
        "noGroupForUserWarningMessage": "L'utilizzo di SKINreporter richiede che l'account utente sia collegato a un gruppo di utenti"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Si è verificato un errore durante il scaricamento",
          "downloadSuccess": "Il documento {docTitle} è stato scaricato",
          "open": "SCARICA IL DOCUMENTO",
          "title": "Condition report di avanzamento completati"
        },
        "inProgress": {
          "edit": "MODIFICARE IL CONDITION REPORT",
          "title": "Condition report in fase di modifica"
        },
        "concernedItem": "Oggetto del museo interessato",
        "nbResults": "{nbRisultati} risultati",
        "noResults": "Nessun risultato"
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Distribuito su",
          "checkForUpdate": {
            "help": "Se è disponibile un aggiornamento, questo verrà installato automaticamente.",
            "title": "Controlla gli aggiornamenti"
          },
          "clearCache": {
            "help": "Se l'utente è offline, questo rimuove l'accesso a tutti i dati memorizzati sul dispositivo.",
            "title": "Svuotare la cache"
          },
          "overrideLocale": {
            "help": "Verrà utilizzata la lingua inglese e le impostazioni del dispositivo verranno ignorate.",
            "title": "Forza la lingua inglese"
          },
          "resetLocaleOverride": {
            "help": "La lingua utilizzata dipende dalle impostazioni del dispositivo.",
            "title": "Reimpostare la lingua"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "É sicuro di volersi scollegare?"
      },
      "offlineRibbon": {
        "offline": "É offline",
        "online": "É connesso a internet"
      },
      "pdfOverviewScreen": {
        "download": "Scaricare",
        "progressBar": {
          "mainLabel": "Generazione di documenti ...",
          "object": "Oggetto",
          "generalDigest": "Valutazione generale",
          "defects": "Alterazioni",
          "contextAndSignatures": "Contesto e firme",
          "documentReady": "Documento pronto!"
        },
        "title": "Panoramica",
        "renderFailureAlert": "Impossibile visualizzare il PDF, riprovare più tardi"
      },
      "pdfDocument": {
        "mainTitlePrefix": "CONDITION REPORT ",
        "objectSection": {
          "sectionTitle": "Oggetto",
          "inventoryNumber": "Numero d’inventario :",
          "title": "Titolo : ",
          "author": "Artista / Autore :",
          "creationDate": "Data di creazione :",
          "typology": "Tipologia :",
          "denomination": "Denominazione :",
          "materialsAndTechniques": "Materiali e tecniche : ",
          "dimensions": "Dimensioni :",
          "institution": "Istituzione :"
        },
        "alterationsSection": {
          "detailedAlteration": "Alterazione dettagliata",
          "noAnnotation": "Nessuna annotazione da visualizzare",
          "observationLabel": "Osservazioni.",
          "sectionTitle": "Dettagli delle modifiche"
        },
        "finalObservationsSection": {
          "sectionTitle": "Osservazioni finali"
        },
        "contextSection": {
          "sectionTitle": "Contesto di questo rapporto sulle condizioni",
          "reportDate": "Data del condition report :",
          "reportReference": "Riferimento del condition report :",
          "comments": "Commenti :",
          "matAndTechs": "Materiali e tecniche : ",
          "reportPlace": "Posizione :",
          "reportType": "Tipo di condition report :",
          "reportReason": "Motivo del condition report :"
        },
        "reportSection": {
          "interventionsToSchedule": "Interventi da pianificare :",
          "sectionTitle": "Rapporto :",
          "signatoriesTitle": "Relazione svolta in presenza di :",
          "stateOfConservation": "Condizioni della proprietà :",
          "treatmentPriority": "Priorità di trattamento :"
        },
        "footer": {
          "prefix": "Condition REPORT ",
          "separator": "- Pagina "
        },
        "generationFailureAlert": "Generazione PDF non riuscita, riprovare più tardi"
      },
      "proxy": {
        "error": {
          "default": "Si è verificato un errore sulla risorsa {uri}",
          "network": "La comunicazione con il server è fallita",
          "notFound": "La risorsa {uri} non è stata trovata",
          "tokenHasExpired": "La sessione è scaduta"
        }
      },
      "search": {
        "noResults": "Nessun risultato",
        "options": {
          "sortType": {
            "creationDate": "Data di creazione",
            "identifier": "ID principale",
            "lastModification": "Ultima modifica",
            "mainTitle": "Titolo principale",
            "referenceNumber": "Numero di riferimento"
          }
        },
        "queryPlaceholder": "Parole chiave o numero di inventario",
        "title": "Oggetti del museo",
        "totalCount": "{totalResults} Risultato(i) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "CREARE UN NUOVO CONDITION REPORT",
        "createNewReportFromLast": "CONDITION REPORT DALL'ULTIMO RISULTATO",
        "institutionLabel": "Istituzione",
        "lastReportLabel": "Ultimo condition report sulle condizioni",
        "materialsAndTechniques": "Materiali / Tecniche",
        "measurements": "Dimensioni",
        "noLinkedItem": "Nessun oggetto è collegato a questo condition report"
      },
      "serviceWorker": {
        "updateAvailable": "È stato installato un aggiornamento. Fare clic qui per ricaricare la pagina o riavviare l'applicazione."
      },
      "signatureModuleScreen": {
        "cardTitle": "Firmatario",
        "eraseSignature": "Firmare di nuovo",
        "missingSignature": "Manca la firma",
        "nameLabel": "Cognome / Nome",
        "presentSignature": "Firma presente",
        "saveSignature": "Registrare",
        "signatureStatus": "Stato della firma",
        "title": "Firme"
      },
      "editItemScreen": {
        "author": "Autore",
        "confirmButton": "Confermare",
        "editButton": "Modificare",
        "inventoryNumber": "Numero di inventario",
        "saveNotification": {
          "errorMessage": "Si è verificato un errore durante il salvataggio dell'oggetto",
          "inventoryNumberNotUnique": "Non può essere convalidato, il numero di identificazione del record esiste già",
          "successMessage": "Il backup dell'oggetto è stato eseguito con successo"
        },
        "deleteNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione dell'oggetto non sincronizzato",
          "successMessage": "L'oggetto è stato eliminato con successo"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Si è verificato un errore durante l'eliminazione delle modifiche non sincronizzate",
          "successMessage": "Le modifiche sono state annullate"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Questo numero di inventario è già stato assegnato"
        },
        "menu": {
          "saveModifications": "Salva le modifiche",
          "deleteNotSynchronizedNewItem": "Cancellare il nuovo oggetto",
          "deleteModificationsNotSynchronized": "Cancellare le modifiche non sincronizzate",
          "offlineWarning": "Le modifiche vengono salvate sul dispositivo",
          "offlineShortWarning": "Modificato su questo dispositivo"
        },
        "fieldDisabledOffline": "Questo campo non è disponibile in modalità offline"
      },
      "editRecordScreen": {
        "foldAll": "Ridurre tutti",
        "unfoldAll": "Aprire tutti",
        "medias": {
          "accordionPanelTitle": "MEDIA"
        }
      },
      "itemCreationImagePopup": {
        "title": "Aggiungi un'immagine",
        "addImage": "AGGIUNGERE UN'IMMAGINE",
        "ignore": "IN SEGUITO, SALTARE QUESTO PASSAGGIO"
      },
      "itemSearchScreen": {
        "createNewItem": "CREARE UN NUOVO OGGETTO"
      },
      "locationSelector": {
        "inputPlaceholder": "Inserire una posizione",
        "title": "Scegliere una posizione",
        "validate": "Convalidare"
      },
      "maskFields": {
        "boolean": {
          "no": "No",
          "undefined": "Non definito",
          "yes": "Sì"
        },
        "entitySelect": {
          "modalPlaceholder": "Parole chiave o identificatori…"
        }
      },
      "synchroModal": {
        "title": "Sincronizzazione",
        "lastFetch": "Ultimo recupero",
        "duration": "Durata",
        "status": "Stato",
        "details": "Dettagli",
        "lastSynchro": "Ultima sincronizzazione",
        "noEntityToSync": "Nessuna entità da sincronizzare",
        "connectionWarningPrefix": "È necessario essere collegati a internet per poter",
        "connectWarningSend": "inviare",
        "connectWarningRetrieve": "recuperare",
        "connectionWarningSuffix": "dati",
        "noDataToSync": "Al momento non ci sono dati da sincronizzare",
        "localIconInfoPrefix": "L'icona",
        "localIconInfoSuffix": " indica che i dati corrispondenti sono stati modificati localmente e dovranno essere sincronizzati con il database remoto.",
        "retrieveAll": "Recupera tutti",
        "finishedSynchros": "sincronizzazioni completate",
        "syncAll": "Sincronizzare tutti",
        "remainsToSynchronize": "Ancora da sincronizzare",
        "cleanImageCache": "Rimozione delle immagini fantasma dalla cache",
        "cachedImagedCleaned": "Le immagini fantasma sono state rimosse!",
        "cleanCacheDown": "Pulire la cache",
        "cacheDownCleaned": "La cache è stata svuotata!",
        "cleanCacheUp": "Cancellare tutte le modifiche non sincronizzate",
        "cacheUpCleaned": "Tutte le modifiche non sincronizzate sono state eliminate!"
      },
      "entityNames": {
        "items": "Articoli",
        "auditRecords": "Schede di raccolta",
        "audits": "Progetti di raccolta",
        "thesaurusTerms": "Termini del thesaurus",
        "thesaurus": "Tesauro",
        "entityFields": "Dati del sistema",
        "collaborators": "Collaboratori",
        "authorities": "Autorità",
        "aliases": "Alias",
        "locations": "Luoghi",
        "conditionReports": "Rapporti sullo stato",
        "works": "Opere",
        "expressions": "Espressioni",
        "manifestations": "Eventi"
      },
      "time": {
        "hours": "ora/e",
        "minutes": "minuti",
        "seconds": "secondo(i)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Creare un termine",
        "openButtonTitle": "Creare un termine",
        "createButton": "Convalidare",
        "anotherTermButton": "Convalidare e creare un altro termine",
        "cancelButton": "Annullare",
        "preferedTermLabel": "Termine preferito :",
        "synonymLabel": "Utilizzato per :",
        "genericTermPlaceholder": "Generico :",
        "selectSpecificLabel": "Selezionare termini specifici",
        "disabledOffline": "La creazione di un nuovo termine non è disponibile quando si utilizza l'applicazione offline."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Creare",
        errors: {
          searchError: "La ricerca non ha avuto successo",
          fetchError: "Impossibile recuperare i termini del thesaurus"
        },
        "modalSearchInputPlaceholder": "Ricerca di un termine",
        "selectionTabTitle": "Selezionare",
        "thesaurusTermSelectorModalTitle": "Selezionare un termine",
        "validate": "Confermare"
      },
      "state": {
        "all": "Tutti",
        "archived": "Archiviato",
        "canceled": "Annullato",
        "finalized": "Completato",
        "inPreparation": "In preparazione",
        "inProgress": "In corso",
        "programmed": "Pianificato",
        "toValidated": "Da convalidare",
        "validated": "Convalidato",
        "aborted": "Non più in uso",
        "success": "Completato con successo",
        "error": "Errore",
        "none": "Nessuna sincronizzazione precedente"
      }
    },
    "no": {
      "actionBar": {
        "bar": {
          "inProgress": "Pågår",
          "latest": "Avsluttet"
        },
        "sideMenu": {
          "saveModifications": "Lagre endringene",
          "reportOverview": "Oversikt over tilstandsrapport",
          "signReport": "Signer tilstandsrapport",
          "closeReport": "Lukk tilstandsrapport",
          "printReport": "Skriv ut tilstandsrapport",
          "deleteReport": "Slett gjeldende tilstandsrapport",
          "deleteReportOfflineWarning": "Advarsel, dette elementet er ikke synkronisert!",
          "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
          "confirmDeletion": "Bekreft sletting"
        }
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Slett endringen",
          "changeAlterationTitle": "Endre tittelen på endringen",
          "changeAlterationType": "Endre type endring",
          "titleModalHeader": "Rediger tittelen på endringen",
          "titleModalButton": "Bekreft"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "Brukernavn og/eller passord er feil",
            "network": "Kommunikasjon med server mislyktes"
          },
          "form": {
            "password": {
              "error": "Vennligst skriv inn brukernavnet ditt",
              "label": "Passord"
            },
            "submit": "Logg Inn",
            "submitting": "Logger inn",
            "username": {
              "error": "Vennligst skriv inn passordet ditt",
              "label": "Brukernavn"
            }
          }
        },
        "renew": {
          "slowNetwork": "Dette tar mer tid enn vanlig. Vennligst ikke avslutt applikasjonen.",
          "spinner": "Får deg online igjen"
        }
      },
      cameraScanner: {
        scanCode: "Skann strekkoden",
        cancel: "Annuleren",
      },
      "closeReportScreen": {
        "important": "VIKTIG",
        "close": "Tilstandsrapporten lukkes",
        "title": "Lukk tilstandsrapport",
        "notificationContent": "Rapporten '{referenceNumber}' er lukket",
        "warningMessage": "Når den er lukket, kan ikke tilstandsrapporten endres eller slettes",
        "warningQuestion": "Er du sikker på at du vil lukke tilstandsrapporten?",
        "transferingFile": "Overfører PDF-dokument...",
        "fileGeneration": "Genererer endelig PDF-dokument...",
        "reportClosing": "Lukker gjeldende tilstandsrapport..."
      },
      "defectTree": {
        "alteration": {
          "alterationLabel": "Type skade:",
          "alterationsTitle": "Skader:",
          "createAlterationButtonLabel": "Skade",
          "levelTitle": "Nivå 3",
          "precisionLabel": "Detalj:",
          "deleteConfirmationMessage": "Bekreft sletting av skaden og -innholdet?",
          "precisionPlaceholder": "Velg underkategori",
          "thesaurusTermWarningMessage": "Den valgte skaden samsvarer ikke med materialet lenger opp",
          "typeOfAlterationPlaceholder": "Velg type observasjon"
        },
        "annotation": {
          "annotationsTitle": "Merknader:",
          "commentsPlaceholder": "Presiser…",
          "deleteConfirmationMessage": "Bekreft sletting ?",
          "defaultImageConfirmationMessage": "Angi som standardbilde ?"
        },
        "defect": {
          "createElementButtonLabel": "Element",
          "deleteConfirmationMessage": "Bekreft sletting av elementet med innhold?",
          "elementLabel": "Element:",
          "precisionLabel": "Detalj",
          "elementPlaceholder": "Navn på elementet",
          "precisionPlaceholder": "Spesifiser…"
        },
        "material": {
          "createMaterialButtonLabel": "Materiale",
          "deleteConfirmationMessage": "Bekreft sletting av materiale med innhold?",
          "levelTitle": "Nivå 2",
          "materialLabel": "Materiale:",
          "materialsTitle": "Materialer:",
          "thesaurusTermWarningMessage": "Det valgte materialet samsvarer ikke med typen observasjon"
        },
        "observation": {
          "createObservationButtonLabel": "Observasjon",
          "deleteConfirmationMessage": "Bekreft sletting av observasjon med innhold?",
          "levelTitle": "Nivå 1",
          "observationLabel": "Type observasjon:",
          "observationsTitle": "Observasjoner:"
        },
        "submit": "Lagre endringene",
        "submitError": "Datatreet kunne ikke oppdateres",
        "submitting": "Lagrer …"
      },
      "drawingEditor": {
        "title": "Detaljert skade",
        "imageTitlePlaceholder": "Tast inn bildetekst",
        "observationLabel": "Obs.{indeks}",
        "observationPlaceholder": "Tast inn en observasjon",
        "validate": "Lagre",
        "alterationLabel": "{index}",
        "alterationModalTitle": "Velg en skade",
        "errors": {
          "missingTitleOrType": "Vennligst oppgi en tittel eller type endring for hver endring"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "Presisjon",
            "validateButton": "Bekreft"
          },
          "titlePlaceHoder": "Tittel på endringen...",
          "typeOfAlterationPlaceholder": "Type endring..."
        }
      },
      "editReportScreen": {
        "reportTitlePrefix": "Rapportnummer {refNumber}",
        "reportStatusInProgress": "Pågår",
        "reportIdentifiers": {
          "accordionPanelTitle": "Rapportens identifikatorer",
          "referenceNumber": "Referansenummer",
          "numberingInformation": "La dette feltet stå tomt for å aktivere den automatiske nummereringen ved neste lagring",
          "otherIdentifiers": "Andre identifikatorer",
          "reportReason": "Årsak til tilstandsrapport",
          "precision": "Presiser",
          "reportType": "Rapporttype",
          "reportTypePlaceholder": "Velg en rapporttype",
          "tabTitle": "Identifikasjon"
        },
        "reportContext": {
          "accordionPanelTitle": "RAPPORTENS KONTEKST",
          "reportDate": "Dato for rapport",
          "reportDoneInThePresenceOf": "Rapport skrevet i nærvær av",
          "andOf": "og",
          "name": "Navn/etternavn, stilling",
          "role": "Stilling",
          "coordinates": "Kontaktinfo",
          "email": "E-post",
          "signer": "Rapporten er signert av:",
          "reportPlace": "Sted",
          "customer": "Kunde/oppdragsgiver",
          "precisions": "Presiser",
          "linkedProject": "Tilknyttet prosjekt",
          "linkedMovement": "Tilknyttet bevegelse",
          "technicsAndMaterials": "Teknikker og materialer",
          "comments": "Kommentarer"
        },
        "alterations": {
          "accordionPanelTitle": "SKADER",
          "mediasSectionTitle": "RAPPORTENS BILDER",
          "globalAlterationSectionTitle": "GENERELLE SKADER",
          "createAlterationForm": {
            "createAlterationButtonTitle": "Opprett",
            "alterationTypeLabel": "Skadetype",
            "precisionLabel": "Presisjon"
          },
          "tabTitle": "Endringer",
          "viewMenu": {
            "alterationTypeView": "Vis etter type endring",
            "imageView": "Bildevisning",
            "titleView": "Vis etter tittel"
          }
        },
        "conservation": {
          "accordionPanelTitle": "KONSERVERING OG MANIPULERING"
        },
        "observations": {
          "tabTitle": "Balanse",
          "accordionPanelTitle": "RAPPORT OG OBSERVASJONER ",
          "commentsFieldLabel": "Kommentarer",
          "interventionToSchedule": "Planlagte intervensjoner",
          "interventionToSchedulePlaceholder": "Velg en intervensjon",
          "interventionToSchedulePrecision": "Presisering:",
          "stateOfConservation": "Objektets tilstand",
          "stateOfConservationPlaceholder": "Velg en tilstand",
          "typeOfStateOfConservation": "Type status",
          "treatmentPriority": "Behandlingsprioritet",
          "treatmentPriorityPlaceholder": "Velg en prioritet"
        },
        "medias": {
          "accordionPanelTitle": "MEDIA"
        },
        "saveAlert": {
          "errorMessage": "Det oppstod en feil under lagring av tilstandsrapporten",
          "successMessage": "Tilstandsrapporten er lagret",
          "inventoryNumberNotUnique": "Umulig validering"
        },
        "deleteAlert": {
          "errorMessage": "Det oppstod en feil ved sletting av tilstandsrapporten",
          "successMessage": "Tilstandsrapporten er slettet"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
          "successMessage": "Endringene er kansellert"
        },
        "fieldDisabledOffline": "Dette feltet er ikke tilgjengelig i frakoblet modus"
      },
      "firewall": {
        "collabWarningMessage": "Kontoen din har ingen tilknyttet samarbeidspartner, det kan hende at appen ikke fungerer",
        "noGroupForUserWarningMessage": "Din brukerkonto må være en del av en brukergruppe for å kunne bruke SKINreporter"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "Det oppstod en feil under nedlastingen ",
          "downloadSuccess": "Dokumentet {docTitle} ble lastet ned",
          "open": "LAST NED DOKUMENTET",
          "title": "Fullførte tilstandsrapporter"
        },
        "inProgress": {
          "edit": "REDIGER TILSTANDSRAPPORT",
          "title": "Tilstandsrapporter under redigering"
        },
        "concernedItem": "Berørt museumsobjekt",
        "nbResults": "{nbResults} resultater",
        "noResults": "Intet resultat"
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "Utplassert den",
          "checkForUpdate": {
            "help": "Er en oppdatering  tilgjengelig, vil den installeres automatisk.",
            "title": "Vennligst se etter oppdateringer"
          },
          "clearCache": {
            "help": "Hvis du er frakoblet, vil denne prosessen fjerne tilgangen til alle data som er lagret på enheten",
            "title": "Tøm hurtigbufferminnet"
          },
          "overrideLocale": {
            "help": "Det engelske språket vil bli brukt, og enhetens innstillinger vil bli ignorert",
            "title": "Overstyr lokalspråket med engelsk"
          },
          "resetLocaleOverride": {
            "help": "Språket som vil brukes, styres av enhetens innstillinger",
            "title": "Tilbakestill språket"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Er du sikker på at du vil logge ut?"
      },
      "offlineRibbon": {
        "offline": "Du er nå offline",
        "online": "Du er nå online"
      },
      "pdfOverviewScreen": {
        "download": "Nedlasting",
        "progressBar": {
          "mainLabel": "Generer dokumentet",
          "object": "Objekt",
          "generalDigest": "Generelle vurderinger",
          "defects": "Skader",
          "contextAndSignatures": "Kontekst og signaturer",
          "documentReady": "Dokumentet er nå klart!"
        },
        "title": "Oversikt",
        "renderFailureAlert": "Kunne ikke gjengi PDF-filen, vennligst prøv igjen"
      },
      "pdfDocument": {
        "mainTitlePrefix": "TILSTANDSRAPPORT -",
        "objectSection": {
          "sectionTitle": "Gjenstand",
          "inventoryNumber": "Inventarnummer:",
          "title": "Tittel:",
          "author": "Kunstner/forfatter:",
          "creationDate": "Opprettelsesdato :",
          "typology": "Typologi:",
          "denomination": "Navn:",
          "materialsAndTechniques": "Materialer og teknikker:",
          "dimensions": "Dimensjoner:",
          "institution": "Institusjon:"
        },
        "alterationsSection": {
          "detailedAlteration": "Skadedetaljer",
          "noAnnotation": "Ingen merknad å vise",
          "observationLabel": "Obs.",
          "sectionTitle": "Skadedetaljer"
        },
        "finalObservationsSection": {
          "sectionTitle": "Siste observasjoner"
        },
        "contextSection": {
          "sectionTitle": "Tilstandsrapportens kontekst",
          "reportDate": "Rapportdato:",
          "reportReference": "Rapportens referanser",
          "comments": "Kommentarer:",
          "matAndTechs": "Teknikker og materialer:",
          "reportPlace": "Plassering:",
          "reportType": "Rapporttype :",
          "reportReason": "Årsak til tilstandsrapport:"
        },
        "reportSection": {
          "interventionsToSchedule": "Intervensjoner å planlegge:",
          "sectionTitle": "Rapport",
          "signatoriesTitle": "Rapport utarbeidet i nærvær av:",
          "stateOfConservation": "Objektets tilstand",
          "treatmentPriority": "Behandlingsprioritet:"
        },
        "footer": {
          "prefix": "TILSTANDSRAPPORT",
          "separator": "- Side"
        },
        "generationFailureAlert": "PDF-generering mislyktes, prøv igjen"
      },
      "proxy": {
        "error": {
          "default": "Det oppsto en feil på ressursen {uri}",
          "network": "Kommunikasjon med serveren har mislyktes",
          "notFound": "Ressursen {uri} ble ikke funnet",
          "tokenHasExpired": "Økten din har utløpt"
        }
      },
      "search": {
        "noResults": "Ingen resultater",
        "options": {
          "sortType": {
            "creationDate": "Opprettelsesdato",
            "identifier": "Hoved identifikator",
            "lastModification": "Siste endring",
            "mainTitle": "Hovedtittel",
            "referenceNumber": "Referansenummer"
          }
        },
        "queryPlaceholder": "Søkeord eller katalognummer",
        "title": "Objekter",
        "totalCount": "{totalResults} resultat(er): 1 - {nbResults}"
      },
      "searchFeaturedCard": {
        "createNewReport": "OPPRETT NY TILSTANDSRAPPORT",
        "createNewReportFromLast": "TILSTANDSRAPPORT SIDEN SISTE RAPPORT",
        "institutionLabel": "Institusjon",
        "lastReportLabel": "Siste tilstandsrapport",
        "materialsAndTechniques": "Materialer / Teknikker",
        "measurements": "Dimensjoner:",
        "noLinkedItem": "Intet objekt er knyttet til denne tilstandsrapporten"
      },
      "serviceWorker": {
        "updateAvailable": "En oppdatering er installert. Du kan enten klikke her for å oppdatere siden eller starte applikasjonen på nytt."
      },
      "signatureModuleScreen": {
        "cardTitle": "Underskriver",
        "eraseSignature": "Signer om igjen",
        "missingSignature": "Tilstandsrapporten er ikke signert",
        "nameLabel": "Navn etternavn",
        "presentSignature": "Tilstandsrapporten er signert",
        "saveSignature": "Lagre",
        "signatureStatus": "Status for signatur",
        "title": "Signaturer"
      },
      "editItemScreen": {
        "author": "Kunstner",
        "inventoryNumber": "Inventarnummer:",
        "confirmButton": "Bekreft",
        "editButton": "Endre",
        "saveNotification": {
          "errorMessage": "Det oppsto en feil under lagring av objektet",
          "inventoryNumberNotUnique": "Umulig validering",
          "successMessage": "Objektet er lagret"
        },
        "deleteNotification": {
          "errorMessage": "Det oppstod en feil under sletting av det usynkroniserte objektet",
          "successMessage": "Objektet er slettet"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Det oppstod en feil under sletting av usynkroniserte endringer",
          "successMessage": "Endringene er kansellert"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Dette inventarnummeret er allerede tildelt"
        },
        "menu": {
          "saveModifications": "Lagre endringene",
          "deleteNotSynchronizedNewItem": "Slett det nye objektet",
          "deleteModificationsNotSynchronized": "Slett usynkroniserte endringer",
          "offlineWarning": "Endringer lagres på denne enheten, du må synkronisere dem med databasen når nettverket er tilbake.",
          "offlineShortWarning": "Endret på denne enheten"
        },
        "fieldDisabledOffline": "Dette feltet er ikke tilgjengelig i frakoblet modus"
      },
      "editRecordScreen": {
        "foldAll": "Reduser alle",
        "unfoldAll": "Distribuere alle",
        "medias": {
          "accordionPanelTitle": "MEDIER"
        }
      },
      "itemCreationImagePopup": {
        "title": "Legg til et bilde",
        "addImage": "LEGG TIL ET BILDE",
        "ignore": "SENERE, IGNORER DETTE TRINNET"
      },
      "itemSearchScreen": {
        "createNewItem": "OPPRETT NYTT ELEMENT"
      },
      "locationSelector": {
        "inputPlaceholder": "Tast inn en plassering",
        "title": "Velg en plassering",
        "validate": "Valider"
      },
      "maskFields": {
        "boolean": {
          "no": "Nei",
          "undefined": "Udefinert",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Søkeord eller identifikatorer…"
        }
      },
      "synchroModal": {
        "title": "Synkronisering",
        "lastFetch": "Siste henting",
        "duration": "Varighet",
        "status": "Status",
        "details": "Detaljer",
        "lastSynchro": "Siste synkronisering",
        "noEntityToSync": "Ingen enhet å synkronisere",
        "connectionWarningPrefix": "Du må ha en internettforbindelse for å kunne",
        "connectWarningSend": "sende",
        "connectWarningRetrieve": "hente",
        "connectionWarningSuffix": "data",
        "noDataToSync": "Ingen data å synkronisere foreløpig",
        "localIconInfoPrefix": "Ikonet",
        "localIconInfoSuffix": " indikerer at de tilsvarende dataene har blitt endret lokalt og må synkroniseres med den eksterne databasen.",
        "retrieveAll": "Hent alle",
        "finishedSynchros": "Ferdige synkroniseringer",
        "syncAll": "Synkroniser alle",
        "remainsToSynchronize": "Gjenstår å synkronisere",
        "cleanImageCache": "Fjerne spøkelsesbilder fra hurtigbufferen",
        "cachedImagedCleaned": "Spøkelsesbildene er fjernet!",
        "cleanCacheDown": "Tøm hurtigbufferen",
        "cacheDownCleaned": "Cachen er tømt!",
        "cleanCacheUp": "Slett alle usynkroniserte endringer",
        "cacheUpCleaned": "Alle usynkroniserte endringer er slettet!"
      },
      "entityNames": {
        "items": "Gjenstander",
        "auditRecords": "Revisjonsskjemaer",
        "audits": "Revisjonsprosjekter",
        "thesaurusTerms": "Termer i tesaurusen",
        "thesaurus": "Tesaurus",
        "entityFields": "Systemdata",
        "collaborators": "Samarbeidspartnere",
        "authorities": "Myndigheter",
        "aliases": "Aliaser",
        "locations": "Plasseringer",
        "conditionReports": "Tilstandsrapporter",
        "works": "Verk",
        "expressions": "Uttrykk",
        "manifestations": "Arrangementer"
      },
      "time": {
        "hours": "time(r)",
        "minutes": "minutt(er)",
        "seconds": "sekund(er)"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Opprett begrep",
        "openButtonTitle": "Opprett vilkår",
        "createButton": "Bekreft",
        "anotherTermButton": "Bekreft og opprett et annet vilkår",
        "cancelButton": "Avbryt",
        "preferedTermLabel": "Foretrukket begrep ",
        "synonymLabel": "Brukes for",
        "genericTermPlaceholder": "Generisk",
        "selectSpecificLabel": "Velg spesifikke termer",
        "disabledOffline": "Det er ikke tillatt å opprette en tesaurusTerm mens du er frakoblet."
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Opprettelse",
        errors: {
          searchError: "Søket var resultatløst",
          fetchError: "Kan ikke hente termer fra tesaurusen"
        },
        "modalSearchInputPlaceholder": "Søke etter en term",
        "selectionTabTitle": "Utvelgelse",
        "thesaurusTermSelectorModalTitle": "Velg et begrep",
        "validate": "Validere"
      },
      "state": {
        "all": "Alle",
        "archived": "Arkivert",
        "canceled": "Kansellert",
        "finalized": "Fullført",
        "inPreparation": "Under forberedelse",
        "inProgress": "pågår",
        "programmed": "Programmert",
        "toValidated": "Trenger validering",
        "validated": "Validert",
        "aborted": "Avbrutt",
        "success": "Fullført",
        "error": "Feil",
        "none": "Ingen tidligere synkronisering"
      }
    },
    "de": {
      "actionBar": {
        "sideMenu": {
          "deleteReportOfflineWarning": "Achtung, dieses Element ist nicht synchronisiert!",
          "deleteModificationsNotSynchronized": "Nicht synchronisierte Änderungen löschen",
          "confirmDeletion": "Löschung bestätigen",
          "saveModifications": "Änderungen abspeichern",
          "reportOverview": "Vorschau des Zustandsprotokolls",
          "signReport": "Zustandsprotokoll unterzeichnen",
          "closeReport": "Zustandsprotokoll abschließen",
          "printReport": "Zustandsprotokoll ausdrucken",
          "deleteReport": "laufendes Zustandsprotokoll löschen"
        },
        "bar": {
          "inProgress": "in Arbeit",
          "latest": "beendet"
        }
      },
      cameraScanner: {
        scanCode: "Barcode scannen",
        cancel: "Abbrechen",
      },
      "defectTree": {
        "annotation": {
          "defaultImageConfirmationMessage": "Als Standardbild festlegen?",
          "annotationsTitle": "Bemerkungen:",
          "commentsPlaceholder": "bitte genau angeben…",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung?"
        },
        "alteration": {
          "alterationLabel": "Art der Beschädigung:",
          "alterationsTitle": "Beschädigungen:",
          "createAlterationButtonLabel": "Beschädigung",
          "levelTitle": "Stufe 3",
          "precisionLabel": "genaue Angabe:",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung der Beschädigung und ihres Inhalts?",
          "precisionPlaceholder": "eine Unterart auswählen",
          "thesaurusTermWarningMessage": "Die Art der ausgewählten Beschädigung entspricht nicht dem oben genannten Material",
          "typeOfAlterationPlaceholder": "Art der Beobachtung auswählen"
        },
        "defect": {
          "createElementButtonLabel": "Element",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung des Elements und seines Inhalts?",
          "elementLabel": "Element:",
          "precisionLabel": "genaue Angabe",
          "elementPlaceholder": "Name des Elements",
          "precisionPlaceholder": "bitte genau angeben…"
        },
        "material": {
          "createMaterialButtonLabel": "Material",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung des Materials und seines Inhalts?",
          "levelTitle": "Stufe 2",
          "materialLabel": "Material",
          "materialsTitle": "Materialien",
          "thesaurusTermWarningMessage": "Das ausgewählte Material entspricht nicht der oben genanten Beobachtungsart"
        },
        "observation": {
          "createObservationButtonLabel": "Beobachtung",
          "deleteConfirmationMessage": "Bestätigen sie die Löschung der Beobachtung und ihres Inhalts?",
          "levelTitle": "Stufe 1",
          "observationLabel": "Art der Beobachtung",
          "observationsTitle": "Beobachtungen:"
        },
        "submit": "die Anderungen abspeichern",
        "submitError": "der Baum konnte nicht aktualisiert werden",
        "submitting": "Speicherung läuft…"
      },
      "drawingEditor": {
        "alterationModalTitle": "eine Beschädigung auswählen",
        "title": "ausführliche Beschreibung der Beschädigung",
        "imageTitlePlaceholder": "Bildunterschrift eingeben",
        "alterationLabel": "{index}",
        "observationPlaceholder": "eine Beobachtung eingeben",
        "validate": "Eingeben",
        "errors": {
          "missingTitleOrType": "Geben sie für jede Beschädigung einen Titel bzw. die Art der Beschädigung ein"
        },
        "alterationLine": {
          "precisionModal": {
            "title": "genaue Angabe",
            "validateButton": "Bestätigen"
          },
          "titlePlaceHoder": "Titel der Beschädigung ",
          "typeOfAlterationPlaceholder": "Art der Beschädigung"
        }
      },
      "editItemScreen": {
        "saveNotification": {
          "inventoryNumberNotUnique": "Bestätigung unmöglich, da die Datensatz-ID bereits existiert",
          "errorMessage": "Bei der Speicherung des Objekts ist ein Fehler aufgetreten",
          "successMessage": "Das Objekt wurde erfolgreich abgespeichert"
        },
        "errorMessages": {
          "inventoryNumberNotUnique": "Diese Inv.-Nr. ist bereits vergeben"
        },
        "fieldDisabledOffline": "Die Eingabe in dieses Feld ist offline nicht möglich",
        "author": "Autor",
        "confirmButton": "Bestätigen",
        "editButton": "Ändern",
        "inventoryNumber": "Inv.-Nr.",
        "deleteNotification": {
          "errorMessage": "Bei der Löschung des nicht synchronisierten Objekts ist ein Fehler aufgetreten",
          "successMessage": "Das Objekt wurde erfolgreich gelöscht"
        },
        "deleteModificationsNotification": {
          "errorMessage": "Bei der Löschung der nicht synchronisierten Änderungen ist ein Fehler aufgetreten",
          "successMessage": "Die Änderungen sind gelöscht worden"
        },
        "menu": {
          "saveModifications": "Änderungen abspeichern",
          "deleteNotSynchronizedNewItem": "das neue Objekt löschen",
          "deleteModificationsNotSynchronized": "nicht synchronisierte Änderungen löschen",
          "offlineWarning": "Die Änderungen sind auf dem Endgerät abgespeichert. Sie müssen mit der Datenbank synchronisiert werden, sobald das Netz wieder verfügbar ist.",
          "offlineShortWarning": "auf diesem Endgerät ändern"
        }
      },
      "editReportScreen": {
        "alterations": {
          "mediasSectionTitle": "BILDMATERIAL ZUSTANDSPROTOKOLL",
          "globalAlterationSectionTitle": "ALLGEMEINE BESCHÄDIGUNGEN",
          "createAlterationForm": {
            "createAlterationButtonTitle": "erstellen",
            "alterationTypeLabel": "Art der Beschädigung",
            "precisionLabel": "genaue Angabe"
          },
          "accordionPanelTitle": "Beschädigungen:",
          "tabTitle": "Alterationen",
          "viewMenu": {
            "alterationTypeView": "Ansicht nach Art der Beschädigung",
            "imageView": "Fotoansicht",
            "titleView": "Ansicht nach Titel"
          }
        },
        "saveAlert": {
          "inventoryNumberNotUnique": "Bestätigung unmöglich, da die Datensatz-ID bereits existiert",
          "errorMessage": "bei der Speicherung des Zustandsprokolls ist ein Fehler aufgetreten",
          "successMessage": "Zustandsprotokoll gespeichert"
        },
        "fieldDisabledOffline": "Die Eingabe in dieses Feld ist offline nicht möglich",
        "reportTitlePrefix": "Zustandsprotokoll Nr.  {refNumber}",
        "reportStatusInProgress": "in Arbeit",
        "reportIdentifiers": {
          "accordionPanelTitle": "ZUSTANDSPROTOKOLL-ID",
          "referenceNumber": "Referenz-Nr.",
          "numberingInformation": "Bitte leer lassen, so dass bei der nächsten Abspeicherung die automatische Nummerierung aktiviert wird",
          "otherIdentifiers": "andere Identifikatoren",
          "reportReason": "Grund der Zustandsbegutachtung",
          "precision": "genaue Angabe:",
          "reportType": "Art des Zustandsprotokolls",
          "reportTypePlaceholder": "eine Art des Zustandsprotokolls auswählen ",
          "tabTitle": "Identifikation"
        },
        "reportContext": {
          "accordionPanelTitle": "KONTEXT DER ZUSTANDSBEGUTACHTUNG",
          "reportDate": "Datum des Protokolls",
          "reportDoneInThePresenceOf": "Protokoll erstellt in Anwesenheit von",
          "andOf": "und von",
          "name": "Name, Vorname, Funktion",
          "role": "Funktion",
          "coordinates": "Kontaktdaten",
          "email": "Email",
          "signer": "Unterschrift",
          "reportPlace": "Ort der Protokollerstellung",
          "customer": "Kunde/Auftraggeber",
          "precisions": "genaue Angaben",
          "linkedProject": "verbundenes Projekt ",
          "linkedMovement": "verbundene Objektbewegung",
          "technicsAndMaterials": "benutzte(s) Technik/Material",
          "comments": "Bemerkungen"
        },
        "conservation": {
          "accordionPanelTitle": "KONSERVIERUNG UND HANDLING"
        },
        "observations": {
          "tabTitle": "Schlussfolgerung",
          "accordionPanelTitle": "BERICHT UND BEOBACHTUNGEN",
          "commentsFieldLabel": "Bemerkungen",
          "interventionToSchedule": "zu planende Maßnahmen",
          "interventionToSchedulePlaceholder": "eine Maßnahme auswählen",
          "interventionToSchedulePrecision": "genaue Angabe:",
          "stateOfConservation": "Zustand des Guts",
          "stateOfConservationPlaceholder": "einen Zustand auswählen",
          "typeOfStateOfConservation": "Art des Zustands",
          "treatmentPriority": "Behandlungspriorität",
          "treatmentPriorityPlaceholder": "eine Priorität auswählen"
        },
        "medias": {
          "accordionPanelTitle": "MEDIEN"
        },
        "deleteAlert": {
          "errorMessage": "bei der Löschung des Zustandsprotokolls ist ein Fehler aufgetreten",
          "successMessage": "Zustandsprotokoll gelöscht"
        },
        "deleteModificationsNotification": {
          "errorMessage": "bei der Löschung der nicht synchronisierten Änderungen  ist ein Fehler aufgetreten",
          "successMessage": "die Änderungen wurden abgebrochen"
        }
      },
      "itemCreationImagePopup": {
        "title": "Bild hinzufügen",
        "addImage": "EIN BILD HINZUFÜGEN",
        "ignore": "SPÄTER DIESE ETAPPE ÜBERGEHEN"
      },
      "itemSearchScreen": {
        "createNewItem": "EIN NEUES OBJEKT ANLEGEN"
      },
      "pdfOverviewScreen": {
        "renderFailureAlert": "PDF-Dokument kann nicht angezeigt werden, bitte versuchen sie es später noch einmal",
        "download": "hochladen",
        "progressBar": {
          "mainLabel": "Erstellung des Dokuments ",
          "object": "Objekt",
          "generalDigest": "allgemeine Beurteilung",
          "defects": "Beschädigungen",
          "contextAndSignatures": "Kontext und Unterschriften",
          "documentReady": "Das Dokument ist bereit!"
        },
        "title": "Vorschau"
      },
      "pdfDocument": {
        "generationFailureAlert": "Die Erstellung des PDF-Dokuments ist fehlgeschlagern, bitte versuchen sie es später noch einmal.",
        "mainTitlePrefix": "ZUSTANDSPROTOKOLL",
        "objectSection": {
          "sectionTitle": "Objekt",
          "inventoryNumber": "Inv.-Nr.",
          "title": "Titel",
          "author": "Künstler/ Autor:",
          "creationDate": "Herstellungsdatum:",
          "typology": "Typologie :",
          "denomination": "Benennung:",
          "materialsAndTechniques": "Material/Technik:",
          "dimensions": "Maße:",
          "institution": "Institution:"
        },
        "alterationsSection": {
          "detailedAlteration": "ausführliche Beschreibung der Beschädigung",
          "noAnnotation": "keine anzuzeigende Anmerkung",
          "observationLabel": "Beobachtung",
          "sectionTitle": "Detailaufnahme der Beschädigung"
        },
        "finalObservationsSection": {
          "sectionTitle": "Abschlussbemerkungen"
        },
        "contextSection": {
          "comments": "Bemerkungen",
          "matAndTechs": "Material/Technik:",
          "reportDate": "Datum des Protokolls",
          "reportPlace": "Ort der Protokollerstellung",
          "reportReference": "Referenz-Nr.",
          "sectionTitle": "Kontext der vorliegenden Zustandsbegutachtung",
          "reportType": "Art des Protokolls :",
          "reportReason": "Grund der Zustandsbegutachtung:"
        },
        "reportSection": {
          "interventionsToSchedule": "zu planende Maßnahmen:",
          "sectionTitle": "Bericht",
          "signatoriesTitle": "Zustandsbegutachtung ausgeführt im Beisein von:",
          "stateOfConservation": "Zustand des Guts",
          "treatmentPriority": "Behandlungspriorität"
        },
        "footer": {
          "prefix": "ZUSTANDSPROTOKOLL",
          "separator": "- Seite"
        }
      },
      "entityNames": {
        "conditionReports": "Zustandsprotokolle",
        "items": "Items",
        "auditRecords": "Inventurberichte",
        "audits": "Inventurvorhaben",
        "thesaurusTerms": "Thesaurusbegriffe",
        "thesaurus": "Thesaurus",
        "entityFields": "Systemdaten",
        "collaborators": "Mitarbeiter",
        "authorities": "Personen/Körperschaften",
        "aliases": "Alias",
        "locations": "Standorte",
        "works": "Werk",
        "expressions": "Expression",
        "manifestations": "Manifestation"
      },
      "thesaurusTermCreateForm": {
        "formTitle": "Erstellung eines Begriff",
        "openButtonTitle": "einen Begriff erstellen",
        "createButton": "bestätigen",
        "anotherTermButton": "bestätigen und einen weiteren Begriff erstellen",
        "cancelButton": "abbrechen",
        "preferedTermLabel": "bevorzugter Begriff: ",
        "synonymLabel": "genutzt für:",
        "genericTermPlaceholder": "Oberbegriff:",
        "selectSpecificLabel": "spezifische Begriffe auswählen",
        "disabledOffline": "Die Erstellung eines neuen Begriffs ist im Offline-Modus nicht möglich"
      },
      "thesaurusTermTree": {
        "creationTabTitle": "Erstellen",
        errors: {
          searchError: "Die Suche ist fehlgeschlagen",
          fetchError: "Thesaurusbegriffe können nicht abgerufen werden"
        },
        "modalSearchInputPlaceholder": "einen Begriff suchen",
        "selectionTabTitle": "auswählen",
        "thesaurusTermSelectorModalTitle": "Einen Begriff auswählen",
        "validate": "bestätigen"
      },
      "alterationCard": {
        "moreMenu": {
          "deleteAlteration": "Beschädigung löschen",
          "changeAlterationTitle": "Titel der Beschädigung ändern",
          "changeAlterationType": "Art der Beschädigung ändern",
          "titleModalHeader": "Titel der Beschädigung bearbeiten",
          "titleModalButton": "Bestätigen"
        }
      },
      "auth": {
        "login": {
          "error": {
            "credentials": "ihre Zugangsdaten sind fehlerhaft",
            "network": "der Verbindungsaufbau ist fehlgeschlagen"
          },
          "form": {
            "password": {
              "error": "Geben sie ihren Benutzernamen ein",
              "label": "Kennwort"
            },
            "submit": "sich einloggen",
            "submitting": "Verbindungsaufbau…",
            "username": {
              "error": "Geben sie ihr Kennwort ein",
              "label": "Benutzername"
            }
          }
        },
        "renew": {
          "slowNetwork": "Der Verbindungsaufbau dauert länger als gewöhnlich, bitte die Anwendung nicht beenden",
          "spinner": "Wiederverbindung …"
        }
      },
      "closeReportScreen": {
        "important": "WICHTIG",
        "close": "Abschließen",
        "title": "Zustandsprotokoll abschließen",
        "notificationContent": "Das Zustandsprotokoll '{referenceNumber}' wurde abschlossen",
        "warningMessage": "Ein abgeschlossenes Zustandsprotokoll kann weder geändert noch gelöscht werden",
        "warningQuestion": "Möchten sie das Zustandsprotokoll wirklich abschließen?",
        "transferingFile": "Übertragung des PDF-Dokuments…",
        "fileGeneration": "Erstellung des endgültigen PDF-Dokuments…",
        "reportClosing": "Abschluss des Zustandsprotokolls"
      },
      "editRecordScreen": {
        "foldAll": "alles einklappen",
        "unfoldAll": "alles aufklappen",
        "medias": {
          "accordionPanelTitle": "MEDIEN"
        }
      },
      "firewall": {
        "collabWarningMessage": "Ihr Account hat keinen zugeordneten Mitarbeiter, die Anwendung funktioniert evtl nicht",
        "noGroupForUserWarningMessage": "Die Arbeit mit SKINreporter setzt voraus, dass ihr Benutzerkonto mit einer Benutzergruppe verknüpft ist"
      },
      "listReportScreen": {
        "closed": {
          "downloadFailure": "während des Hochladens ist ein Fehler aufgetreten",
          "downloadSuccess": "das Dokument  {docTitle} wurde hochgeladen",
          "open": "EIN DOKUMENT HOCHLADEN",
          "title": "abgeschlossene Zustandsbegutachtungen"
        },
        "inProgress": {
          "edit": "DAS ZUSTANDSPROTOKOLL BEARBEITEN",
          "title": "Zustandsprotokolle in Bearbeitung"
        },
        "concernedItem": "betreffendes Museumsobjekt",
        "nbResults": "{nbResults} Ergebnisse",
        "noResults": "kein Ergebnis"
      },
      "locationSelector": {
        "inputPlaceholder": "einen Standort eingeben",
        "title": "einen Standort auswählen",
        "validate": "bestätigen"
      },
      "maskFields": {
        "boolean": {
          "no": "Nein",
          "undefined": "nicht definiert",
          "yes": "Ja"
        },
        "entitySelect": {
          "modalPlaceholder": "Schlagworte oder ID"
        }
      },
      "navbar": {
        "contextMenuModal": {
          "buildDate": "aufgeklappt ...",
          "checkForUpdate": {
            "help": "Falls ein Update verfügbar ist, wird es automatisch installiert.",
            "title": "Updates überprüfen"
          },
          "clearCache": {
            "help": "Sind Sie offline, wird der Zugriff auf alle auf dem Endgerät gespeicherten Daten gelöscht.",
            "title": "Cache leeren"
          },
          "overrideLocale": {
            "help": "Es wird die englische Sprache verwendet und die Einstellung Ihres Endgeräts ignoriert.",
            "title": "Spracheinstellung Englisch erzwingen"
          },
          "resetLocaleOverride": {
            "help": "Die verwendete Sprache hängt von den Einstellungen Ihres Endgeräts ab.",
            "title": "Spracheinstellung zurücksetzen"
          },
          "title": "Skin-REPORTER"
        },
        "logout": "Möchten sie sich wirklich abmelden?"
      },
      "offlineRibbon": {
        "offline": "Sie sind offline",
        "online": "Sie sind online"
      },
      "proxy": {
        "error": {
          "default": "bei der Ressource  {uri} ist ein Fehler aufgetreten",
          "network": "keine Verbindung zum Server",
          "notFound": "die Ressource {uri} kann nicht gefunden werden",
          "tokenHasExpired": "ihre Sitzung ist abgelaufen"
        }
      },
      "search": {
        "noResults": "keine Ergebnis",
        "options": {
          "sortType": {
            "creationDate": "Datum des Protokolls",
            "identifier": "Haupt-ID",
            "lastModification": "letzte Änderung",
            "mainTitle": "Haupttitel",
            "referenceNumber": "Referenz-Nr."
          }
        },
        "queryPlaceholder": "Stichwort oder Inv.-Nr.",
        "title": "Museumsobjekt",
        "totalCount": "{totalResults} Ergebnis(se) : 1 -"
      },
      "searchFeaturedCard": {
        "createNewReport": "EIN NEUES ZUSTANDSPROTOKOLL ERSTELLEN",
        "createNewReportFromLast": "ZUSTANDSPROTOKOLL AUS DEM VORHERIGEN PROTOKOLL",
        "institutionLabel": "Institution",
        "lastReportLabel": "vorherige Zustandsbegutachtung",
        "materialsAndTechniques": "Material/Technik",
        "measurements": "Maße",
        "noLinkedItem": "für dieses Protokoll wurde kein Item gefunden"
      },
      "serviceWorker": {
        "updateAvailable": "Es wurde ein Update installiert. Klicken Sie hier, um die Seite neu zu laden oder starten Sie die Anwendung neu."
      },
      "signatureModuleScreen": {
        "cardTitle": "Unterzeichner",
        "eraseSignature": "Unterschrift wiederholen",
        "missingSignature": "fehlende Unterschrift",
        "nameLabel": "Name/Vorname",
        "presentSignature": "vorliegende Unterschrift",
        "saveSignature": "speichern",
        "signatureStatus": "Status der Unterschrift",
        "title": "Unterschriften"
      },
      "synchroModal": {
        "title": "Synchronisation",
        "lastFetch": "letzter Abruf ",
        "duration": "Dauer",
        "status": "Status",
        "details": "Details",
        "lastSynchro": "letzte Synchronisation",
        "noEntityToSync": "keine zu synchronisierenden Entitäten",
        "connectionWarningPrefix": "Sie müssen mit dem Internet verbunden sein, um zu",
        "connectWarningSend": "senden",
        "connectWarningRetrieve": "wiederherstellen",
        "connectionWarningSuffix": "von Daten",
        "noDataToSync": "aktuell keine zu synchronisierende Angabe",
        "localIconInfoPrefix": "Das Icon",
        "localIconInfoSuffix": "gibt an, dass die entsprechenden Daten lokal geändert wurden und mit der festgelegten Datenbank synchronisiert werden müssen.",
        "retrieveAll": "alles wiederherstellen",
        "finishedSynchros": "Abgeschlossene Synchronisationen ",
        "syncAll": "alles synchronisieren",
        "remainsToSynchronize": "noch zu synchronisieren",
        "cleanImageCache": "Geisterbilder des Cache löschen",
        "cachedImagedCleaned": "die Geisterbilder sind gelöscht worden!",
        "cleanCacheDown": "Cache leeren",
        "cacheDownCleaned": "der Cache wurde geleert",
        "cleanCacheUp": "alle nicht synchronisierten Änderungen löschen",
        "cacheUpCleaned": "alle nicht synchronisierten Änderungen sind gelöscht worden"
      },
      "time": {
        "hours": "Stunde(n)",
        "minutes": "Minute(n)",
        "seconds": "Sekunde(n)"
      },
      "state": {
        "all": "alle",
        "archived": "archiviert",
        "canceled": "abgebrochen",
        "finalized": "beendet",
        "inPreparation": "in Vorbereitung",
        "inProgress": "in Arbeit",
        "programmed": "geplant",
        "toValidated": "zu bestätigen",
        "validated": "bestätigt",
        "aborted": "unterbrochen",
        "success": "erfolgreich beendet",
        "error": "Fehler",
        "none": "keine vorhergehende Synchronisation"
      }
    },
    "se": {
      cameraScanner: {
          scanCode: "MISSING TRANSLATION",
          cancel: "MISSING TRANSLATION",
      },
      editReportScreen: {
        "alterations": {
          "mediasSectionTitle": "MISSING TRANSLATION",
          "globalAlterationSectionTitle": "MISSING TRANSLATION",
          "createAlterationForm": {
            "createAlterationButtonTitle": "MISSING TRANSLATION",
            "alterationTypeLabel": "MISSING TRANSLATION",
            "precisionLabel": "MISSING TRANSLATION"
          },
          "accordionPanelTitle": "MISSING TRANSLATION",
          "tabTitle": "MISSING TRANSLATION",
          "viewMenu": {
            "alterationTypeView": "MISSING TRANSLATION",
            "imageView": "MISSING TRANSLATION",
            "titleView": "MISSING TRANSLATION"
          }
        },
        "reportTitlePrefix": "MISSING TRANSLATION",
        "reportStatusInProgress": "MISSING TRANSLATION",
        "reportIdentifiers": {
          "accordionPanelTitle": "MISSING TRANSLATION",
          "referenceNumber": "MISSING TRANSLATION",
          "numberingInformation": "MISSING TRANSLATION",
          "otherIdentifiers": "MISSING TRANSLATION",
          "reportReason": "MISSING TRANSLATION",
          "precision": "MISSING TRANSLATION",
          "reportType": "MISSING TRANSLATION",
          "reportTypePlaceholder": "MISSING TRANSLATION",
          "tabTitle": "MISSING TRANSLATION"
        },
        "reportContext": {
          "accordionPanelTitle": "MISSING TRANSLATION",
          "reportDate": "MISSING TRANSLATION",
          "reportDoneInThePresenceOf": "MISSING TRANSLATION",
          "andOf": "MISSING TRANSLATION",
          "name": "MISSING TRANSLATION",
          "role": "MISSING TRANSLATION",
          "coordinates": "MISSING TRANSLATION",
          "email": "MISSING TRANSLATION",
          "signer": "MISSING TRANSLATION",
          "reportPlace": "MISSING TRANSLATION",
          "customer": "MISSING TRANSLATION",
          "precisions": "MISSING TRANSLATION",
          "linkedProject": "MISSING TRANSLATION",
          "linkedMovement": "MISSING TRANSLATION",
          "technicsAndMaterials": "MISSING TRANSLATION",
          "comments": "MISSING TRANSLATION"
        },
      },
      "thesaurusTermTree": {
        "creationTabTitle": "MISSING TRANSLATION",
        errors: {
          searchError: "Sökningen var resultatlös",
          fetchError: "Det gick inte att hämta thesaurus-termer"
        },
        "modalSearchInputPlaceholder": "MISSING TRANSLATION",
        "selectionTabTitle": "MISSING TRANSLATION",
        "thesaurusTermSelectorModalTitle": "MISSING TRANSLATION",
        "validate": "MISSING TRANSLATION"
      },
    },
}

export const dateTimeFormats = {
  en: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "en-us": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  fr: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  "fr-ca": {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  nl: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  es: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  it: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  no: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  de: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
  se: {
      short: {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
      },
      shortTime: {
          day: '2-digit',
          hour: 'numeric',
          minute: 'numeric',
          month: '2-digit',
          second: 'numeric',
          year: 'numeric',
      },
      year: {
          year: 'numeric',
      },
  },
}
